{
  "addons.addonList": "Lista dodataka",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Izradite i dohvatite svoj API ključ s ove veze",
  "addons.ambientWeatherDescription": "Ambijentalne meteorološke stanice (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "API ključ",
  "addons.applicationKey": "Aplikacijski ključ",
  "addons.connect": "Poveži",
  "addons.davisApiSecret": "Tajni API",
  "addons.davisApiV2Key": "API ključ V2",
  "addons.davisDescription": "Davis meteorološke stanice (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Dohvatite svoje V2 API ključeve s ove veze",
  "addons.disconnect": "Prekini vezu",
  "addons.ecowittCreateAndRetrieveKeys": "Izradite i dohvatite svoj API ključ i ključ aplikacije putem ove veze",
  "addons.ecowittDescription": "Ecowitt nudi profesionalne meteorološke stanice, bežične unutarnje/vanjske termometre, kišomjere visoke preciznosti, senzore kvalitete zraka i još mnogo toga.",
  "addons.helpLink": "Kako povezati {provider}",
  "addons.myAcuriteAccountOnHold": "Vaš račun je stavljen na čekanje. Molimo unesite svoju lozinku kako biste ponovno povezali svoj račun",
  "addons.myAcuriteDescription": "AcuRite je marka meteoroloških stanica broj 1 u Sjevernoj Americi. Kao predvodnik u tehnologiji vremena, temperature i vremena, AcuRite vam pruža detaljne informacije o vašem unutarnjem i vanjskom okruženju kako biste s povjerenjem mogli planirati svoj dan.",
  "addons.myAcuriteEnterCredentials": "Unesite svoje My AcuRite vjerodajnice kako biste povezali svoj My AcuRite račun sa SmartMixin",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Da promijenite temperaturu u domu, bilo iz kreveta bilo sa druge strane svijeta, koristite Netatmo Thermostat.",
  "addons.netatmoThermostat": "Netatmo Thermostat",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Vaša osobna meteorološka stanica",
  "addons.or": "ili",
  "addons.providerAccountDisconnected": "Veza s vašom meteorološkom uslugom je istekla. Ponovno se povežite za nastavak ažuriranja podataka.",
  "addons.reconnect": "Poveži ponovo",
  "addons.weatherflowCreateToken": "Stvorite i dohvatite svoj token putem ove veze",
  "addons.weatherflowTempestDescription": "Vremenska stanica Tempest koju je razvio Weatherflow",
  "addons.wundergroundApiKey": "API ključ",
  "addons.wundergroundDescription": "Weather Underground je globalna zajednica ljudi koji povezuju podatke sa senzora za okoliš poput meteoroloških stanica i monitora kvalitete zraka kako bismo mogli isporučiti bogate, hiperlokalne podatke koji su vam potrebni da potaknete svoje strasti.",
  "addons.wundergroundRetrieveApiKey": "Dohvatite svoj API ključ s ove veze",
  "addons.wundergroundRetrieveStationId": "Dohvatite svoj identifikator postaje (ID) s ove veze",
  "addons.wundergroundStationId": "ID postaje",
  "airQuality.adviceActivityGood": "Idealan dan za kretanje na otvorenom",
  "airQuality.adviceActivityHazardous": "Izbjegavajte svaku tjelesnu aktivnost na otvorenom",
  "airQuality.adviceActivityLabel": "Tjelesna aktivnost",
  "airQuality.adviceActivityModerate": "Dobar dan za kretanje na otvorenom",
  "airQuality.adviceActivitySensitive": "Razmislite o kraćim i manje intenzivnim aktivnostima na otvorenom",
  "airQuality.adviceActivityUnhealthy": "Smanjite duge ili intenzivne aktivnosti i češće se odmarajte",
  "airQuality.adviceActivityVeryUnhealthy": "Izbjegavajte duge ili intenzivne aktivnosti; razmislite o premještanju u zatvoreni prostor",
  "airQuality.adviceGroupsGood": "Nisu potrebne posebne mjere opreza",
  "airQuality.adviceGroupsHazardous": "Ostanite u zatvorenom prostoru i smanjite aktivnost",
  "airQuality.adviceGroupsLabel": "Osjetljive skupine",
  "airQuality.adviceGroupsModerate": "Osobito osjetljive osobe: kraće i manje intenzivne aktivnosti",
  "airQuality.adviceGroupsSensitive": "Kraće i manje intenzivne aktivnosti na otvorenom, uz više odmora",
  "airQuality.adviceGroupsUnhealthy": "Izbjegavajte duge ili intenzivne aktivnosti na otvorenom; razmislite o premještanju u zatvoreni prostor",
  "airQuality.adviceGroupsVeryUnhealthy": "Izbjegavajte svaku tjelesnu aktivnost na otvorenom; odgodite je ili premjestite u zatvoreni prostor",
  "airQuality.adviceTimingLabel": "Kada izaći van",
  "airQuality.adviceTimingMorning": "Najbolje ujutro — tada je razina ozona niža",
  "airQuality.airQuality": "Kvaliteta zraka",
  "airQuality.airQualityIndex": "Indeks kvaliteta zraka",
  "airQuality.aqiForecast": "Prognoza kvalitete zraka",
  "airQuality.co": "Ugljen monoksid",
  "airQuality.dailyForecast": "Dnevna prognoza",
  "airQuality.details": "Detalji",
  "airQuality.dominantPollutant": "Dominantni onečišćivač",
  "airQuality.expectedPeak": "Očekivani vrhunac",
  "airQuality.good": "Dobro",
  "airQuality.goodDescription": "Kvaliteta zraka je zadovoljavajuća i zagađenost zraka predstavlja malu opasnost.",
  "airQuality.hazardous": "Opasno",
  "airQuality.hazardousDescription": "Zdravstveno upozorenje: sve osobe su pod rizikom ozbiljnih zdravstvenih tegoba.",
  "airQuality.indoorAirQuality": "Kvaliteta zraka u zatvorenom prostoru",
  "airQuality.mgm3": "mg/m³",
  "airQuality.moderate": "Umjereno",
  "airQuality.moderateDescription": "Kvaliteta zraka je prihvatljiva; ipak manji broj osjetljivih osoba koje su izrazito osjetljive na zagađenost zraka može imati tegobe",
  "airQuality.no2": "Dušični dioksid",
  "airQuality.noForecastForLocation": "Za ovu lokaciju nije dostupna prognoza kvalitete zraka.",
  "airQuality.now": "Sada",
  "airQuality.o3": "Ozon",
  "airQuality.pm10": "Čestice promjera 10 μm i manje",
  "airQuality.pm25": "Čestice promjera 2.5 μm i manje",
  "airQuality.pollutants": "Onečišćujuće tvari",
  "airQuality.ppb": "ppb",
  "airQuality.recommendations": "Preporuke",
  "airQuality.sensitiveUnhealthy": "Osjetljive osobe su ugrožene",
  "airQuality.sensitiveUnhealthyDescription": "Jako osjetljive osobe mogu osjetiti tegobe. Prosječna zdrava osoba neće imati problema.",
  "airQuality.so2": "Sumpor dioksid",
  "airQuality.subIndex": "AQI podindeks",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Razumijevanje indeksa",
  "airQuality.unhealthy": "Nezdravo",
  "airQuality.unhealthyDescription": "Svi će osjetiti tegobe. Jako osjetljive osobe mogu imati izraženije simptome.",
  "airQuality.veryUnhealthy": "Veoma nezdravo",
  "airQuality.veryUnhealthyDezscription": "Upozorenje na povećani rizik. Sve osobe će vjerovatno osjetiti simptome.",
  "alerts.addAlert": "Dodajte upozorenje",
  "alerts.addCondition": "Dodaj uvjet",
  "alerts.alertAdded": "Upozorenje je uspješno dodano",
  "alerts.alertAuthorizationNotice": "Upozorenja mogu funkcionirati samo ako dopustite SmartMixinu da prikazuje obavijesti",
  "alerts.alertDeleted": "Upozorenje je uspješno izbrisano",
  "alerts.alertEdited": "Upozorenje je uspješno izmijenjeno",
  "alerts.alertName": "Naziv upozorenja",
  "alerts.alertWhen": "Želim biti upozoren",
  "alerts.aqiGreaterThan": "AQI veći od",
  "alerts.aqiGreaterThanThreshold": "AQI iznad praga {value}{unit}",
  "alerts.aqiLessThan": "AQI manji od",
  "alerts.aqiLessThanThreshold": "AQI ispod {value}{unit} praga",
  "alerts.atLeastOneCondition": "Morate dodati barem jedan uvjet",
  "alerts.co2GreaterThan": "CO2 veći od",
  "alerts.co2GreaterThanThreshold": "CO2 iznad {value}{unit} praga",
  "alerts.co2LessThan": "CO2 manji od",
  "alerts.co2LessThanThreshold": "CO2 ispod {value}{unit} praga",
  "alerts.conditions": "Pojmovi",
  "alerts.createAlert": "Kreiraj upozorenje",
  "alerts.dailyPrecipitationGreaterThan": "Dnevne oborine veće od",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Dnevne oborine iznad praga od {value}{unit}",
  "alerts.deleteAlert": "Izbriši upozorenje",
  "alerts.editAlert": "Uredi upozorenje",
  "alerts.editCondition": "Promjena uvjeta",
  "alerts.gustSpeedGreaterThan": "Udar vjetra veći od",
  "alerts.gustSpeedGreaterThanThreshold": "Udar vjetra iznad {value}{unit} praga",
  "alerts.gustSpeedLessThan": "Udar vjetra manji od",
  "alerts.gustSpeedLessThanThreshold": "Udar vjetra ispod {value}{unit} praga",
  "alerts.heatIndexGreaterThan": "Indeks toplote veći od",
  "alerts.heatIndexGreaterThanThreshold": "Indeks toplote iznad {value}{unit} praga",
  "alerts.heatIndexLessThan": "Indeks toplote manji od",
  "alerts.heatIndexLessThanThreshold": "Indeks toplote ispod {value}{unit} praga",
  "alerts.humidexGreaterThan": "Humidex veći od",
  "alerts.humidexGreaterThanThreshold": "Humidex iznad {value}{unit} praga",
  "alerts.humidexLessThan": "Humidex manji od",
  "alerts.humidexLessThanThreshold": "Humidex ispod {value}{unit} praga",
  "alerts.humidityGreaterThan": "Vlažnost iznad",
  "alerts.humidityGreaterThanThreshold": "Vlažnost iznad praga {value}{unit}",
  "alerts.humidityLessThan": "Vlažnost ispod",
  "alerts.humidityLessThanThreshold": "Vlažnost ispod praga od {value}{unit}",
  "alerts.inProgress": "U nastajanju",
  "alerts.myAlerts": "Moja upozorenja",
  "alerts.noConfiguredAlert": "Još nemate upozorenje, dodajte ga",
  "alerts.noiseGreaterThan": "Buka veća od",
  "alerts.noiseGreaterThanThreshold": "Buka iznad {value}{unit} praga",
  "alerts.noiseLessThan": "Buka manja od",
  "alerts.noiseLessThanThreshold": "Buka ispod {value}{unit} praga",
  "alerts.noteOnConditions": "Imajte na umu da se upozorenje aktivira kada se potvrde svi dolje navedeni uvjeti",
  "alerts.noTriggerHistory": "Ovo upozorenje još nije aktivirano.",
  "alerts.pm10GreaterThan": "PM 10 veći od",
  "alerts.pm10GreaterThanThreshold": "PM 10 iznad {value}{unit} praga",
  "alerts.pm10LessThan": "PM 10 manje od",
  "alerts.pm10LessThanThreshold": "PM 10 ispod {value}{unit} praga",
  "alerts.pm1GreaterThan": "PM 1 veći od",
  "alerts.pm1GreaterThanThreshold": "PM 1 iznad {value}{unit} praga",
  "alerts.pm1LessThan": "PM 1 manje od",
  "alerts.pm1LessThanThreshold": "PM 1 ispod {value}{unit} praga",
  "alerts.pm2p5GreaterThan": "PM 2,5 veći od",
  "alerts.pm2p5GreaterThanThreshold": "PM 2,5 iznad {value}{unit} praga",
  "alerts.pm2p5LessThan": "PM 2,5 manje od",
  "alerts.pm2p5LessThanThreshold": "PM 2,5 ispod {value}{unit} praga",
  "alerts.postStormSummary": "Sažetak nakon oborina",
  "alerts.postStormSynopsisHelper": "Primit ćete obavijest sa sažetkom nakon svake kiše.",
  "alerts.postStormSynopsisSoleCondition": "Sažetak nakon oluje ne može se kombinirati s drugim uvjetima.",
  "alerts.precipitationGreaterThan": "Satne oborine veće od",
  "alerts.precipitationGreaterThanThreshold": "Satne oborine iznad praga od {value}{unit}",
  "alerts.pressureGreaterThan": "Tlak veći od",
  "alerts.pressureGreaterThanThreshold": "Tlak iznad {value}{unit} praga",
  "alerts.pressureLessThan": "Tlak manji od",
  "alerts.pressureLessThanThreshold": "Tlak ispod {value}{unit} praga",
  "alerts.rainRateGreaterThan": "Intenzitet kiše veći od",
  "alerts.rainRateGreaterThanThreshold": "Intenzitet kiše iznad praga od {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Sunčevo zračenje veće od",
  "alerts.solarRadiationGreaterThanThreshold": "Sunčevo zračenje iznad {value}{unit} praga",
  "alerts.solarRadiationLessThan": "Sunčevo zračenje manje od",
  "alerts.solarRadiationLessThanThreshold": "Sunčevo zračenje ispod {value}{unit} praga",
  "alerts.stormChartUnavailable": "Povijest kiše za ove oborine nije dostupna.",
  "alerts.stormDetail": "Sažetak oborina",
  "alerts.stormDuration": "Trajanje",
  "alerts.stormEnd": "Kraj",
  "alerts.stormPeakRate": "Najveći intenzitet kiše",
  "alerts.stormStart": "Početak",
  "alerts.stormTotal": "Ukupne oborine",
  "alerts.temperatureGreaterThan": "Temperatura iznad",
  "alerts.temperatureGreaterThanThreshold": "Temperatura iznad {value}{unit} praga",
  "alerts.temperatureLessThan": "Temperatura ispod",
  "alerts.temperatureLessThanThreshold": "Temperatura ispod {value}{unit} praga",
  "alerts.thswGreaterThan": "THSW veći od",
  "alerts.thswGreaterThanThreshold": "THSW iznad {value}{unit} praga",
  "alerts.thswLessThan": "THSW manji od",
  "alerts.thswLessThanThreshold": "THSW ispod {value}{unit} praga",
  "alerts.thwGreaterThan": "THW veći od",
  "alerts.thwGreaterThanThreshold": "THW iznad {value}{unit} praga",
  "alerts.thwLessThan": "THW manji od",
  "alerts.thwLessThanThreshold": "THW ispod {value}{unit} praga",
  "alerts.triggerHistory": "Povijest upozorenja",
  "alerts.uvGreaterThan": "UV veći od",
  "alerts.uvGreaterThanThreshold": "UV iznad {value}{unit} praga",
  "alerts.uvLessThan": "UV niži od",
  "alerts.uvLessThanThreshold": "UV ispod {value}{unit} praga",
  "alerts.visibilityGreaterThanThreshold": "Vidljivost ispod {value}{unit} praga",
  "alerts.visibilityLessThanThreshold": "Vidljivost ispod {value}{unit} praga",
  "alerts.visiblityGreaterThan": "Vidljivost manja od",
  "alerts.visiblityLessThan": "Vidljivost manja od",
  "alerts.whichMeasure": "Za koju mjeru želite biti upozoreni?",
  "alerts.whichModule": "Na koji biste modul željeli biti upozoreni?",
  "alerts.windChillGreaterThan": "Hlađenje vjetra veći od",
  "alerts.windChillGreaterThanThreshold": "Hlađenje vjetra iznad {value}{unit} praga",
  "alerts.windChillLessThan": "Hlađenje vjetra manji od",
  "alerts.windChillLessThanThreshold": "Hlađenje vjetra ispod {value}{unit} praga",
  "alerts.windSpeedGreaterThan": "Vjetar jači od",
  "alerts.windSpeedGreaterThanThreshold": "Vjetar iznad {value}{unit} praga",
  "alerts.windSpeedLessThan": "Vjetar manje od",
  "alerts.windSpeedLessThanThreshold": "Vjetar ispod {value}{unit} praga",
  "astral.aboveHorizonAllDay": "Cijeli dan iznad horizonta",
  "astral.aboveTheHorizon": "iznad horizonta",
  "astral.apparentSize": "Prividni promjer",
  "astral.apparentSizeAcross": "{size} u promjeru",
  "astral.astronomicalDawn": "Astronomska zora",
  "astral.astronomicalDusk": "Astronomski sumrak",
  "astral.astronomicalSunPhase": "Astronomski {sunPhase}",
  "astral.belowHorizonAllDay": "Cijeli dan ispod horizonta",
  "astral.belowHorizonSince": "Ispod horizonta od {time}",
  "astral.belowHorizonSinceOn": "Ispod horizonta od {day} {time}",
  "astral.brightAllNight": "Svijetlo cijelu noć — nikad potpuno mračno",
  "astral.brightestMoment": "Najsvjetliji trenutak",
  "astral.civilDawn": "Građanska zora",
  "astral.civilDusk": "Građanski sumrak",
  "astral.civilSunPhase": "Civil {sunPhase}",
  "astral.darkSkyBetween": "Tamno nebo {from} → {to}",
  "astral.darkSkyWindow": "Tamno nebo {from} → {to} · {duration} bez Mjeseca",
  "astral.dawn": "Svitanje",
  "astral.dayLength": "Duljina dana",
  "astral.daylightThroughTheYear": "Duljina dana tijekom godine",
  "astral.dayOfCycle": "dan {day} od {total}",
  "astral.doesNotOccurToday": "Danas se ne događa",
  "astral.domeHint": "Povucite za kretanje kroz noć",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.dusk": "Sumrak",
  "astral.earliestSunrise": "Najraniji izlazak sunca",
  "astral.earliestSunset": "Najraniji zalazak sunca",
  "astral.equinox": "Ravnodnevica",
  "astral.equinoxIn": "Ravnodnevica za {days, plural, one {# dan} few {# dana} other {# dana}}",
  "astral.evening": "Večer",
  "astral.exactPhaseAt": "Točno u {time}",
  "astral.firstQuarter": "Prva četvrt",
  "astral.firstSunriseIn": "Prvi izlazak sunca za {days, plural, one {# dan} few {# dana} other {# dana}}",
  "astral.firstSunsetIn": "Prvi zalazak sunca za {days, plural, one {# dan} few {# dana} other {# dana}}",
  "astral.fullMoon": "Puni mjesec",
  "astral.goldenHourBegins": "Početak zlatnog sata",
  "astral.goldenHourEnds": "Kraj zlatnog sata",
  "astral.highestPoint": "Najviša točka",
  "astral.inDays": "za {days, plural, one {# dan} few {# dana} other {# dana}}",
  "astral.lastQuarter": "Zadnja četvrt",
  "astral.latestSunrise": "Najkasniji izlazak sunca",
  "astral.latestSunset": "Najkasniji zalazak sunca",
  "astral.litShort": "Osvijetl.",
  "astral.longestDay": "Najdulji dan",
  "astral.lowestPoint": "Najniža točka",
  "astral.maxAltitudeShort": "Maks.",
  "astral.midday": "Podne",
  "astral.midnightSun": "Ponoćno sunce",
  "astral.midnightSunPeriod": "Ponoćno sunce",
  "astral.milestoneFootnotePolar": "Ovdje sunce {days, plural, one {# dan} few {# dana} other {# dana}} u godini niti izlazi niti zalazi, pa popis umjesto uobičajenih krajnosti izlaska i zalaska pokazuje kada se to događa.",
  "astral.milestoneFootnoteTemperate": "Najraniji zalazak i najkasniji izlazak ne padaju na najkraći dan — ta dva datuma određuje jednadžba vremena, a ne solsticij.",
  "astral.moon": "Mjesec",
  "astral.moonAltitude": "Visina",
  "astral.moonDirection": "Azimut",
  "astral.moonDistance": "Udaljenost",
  "astral.moonlessFor": "{duration} bez Mjeseca",
  "astral.moonPhases": "Mjesečeve mijene",
  "astral.moonrise": "Izlazak mjeseca",
  "astral.moonset": "Zalazak mjeseca",
  "astral.moonUpAllNight": "Mjesec je iznad horizonta cijelu noć",
  "astral.moonWashesOutNight": "Mjesec je iznad horizonta od {rise} do {set} i osvjetljava cijelu noć",
  "astral.morning": "Jutro",
  "astral.nauticalDawn": "Nautička zora",
  "astral.nauticalDusk": "Nautički sumrak",
  "astral.nauticalSunPhase": "Nautički {sunPhase}",
  "astral.newMoon": "Mladi mjesec",
  "astral.nextDay": "+1 dan",
  "astral.nextProperlyDarkNight": "Sljedeća uistinu tamna noć",
  "astral.nextRise": "sljedeći izlazak u {time}",
  "astral.nextRiseOn": "sljedeći izlazak {day} u {time}",
  "astral.nextSevenNights": "Sljedećih sedam noći",
  "astral.noAstronomicalDarknessTonight": "Noćas nema astronomske tame",
  "astral.noDarkNightAhead": "Nema je u sljedeća dva tjedna",
  "astral.noon": "Podne",
  "astral.noSunriseToday": "Danas nema izlaska sunca",
  "astral.nowAtBearing": "sada {altitude} · azimut {direction}",
  "astral.observing": "Promatranje",
  "astral.ofDaylightLeft": "dnevnog svjetla preostalo",
  "astral.overTheNextThreeWeeks": "tijekom sljedeća 3 tjedna",
  "astral.percentLit": "{percent} osvijetljeno",
  "astral.polarNight": "Polarna noć",
  "astral.polarNightPeriod": "Polarna noć",
  "astral.remainingDaylight": "Preostala obdanica",
  "astral.rightNow": "Upravo sada",
  "astral.riseShort": "Izlazak",
  "astral.setShort": "Zalazak",
  "astral.shortestDay": "Najkraći dan",
  "astral.solarNoon": "Pravo podne",
  "astral.solstice": "Solsticij",
  "astral.sunBelowHorizon": "Sunce {degrees}° ispod horizonta",
  "astral.sunEvents": "Sunčevi događaji",
  "astral.sunNeverDarkEnough": "Sunce nikad ne pada 18° ispod horizonta",
  "astral.sunNeverSets": "Sunce ne zalazi",
  "astral.sunrise": "Izlazak sunca",
  "astral.sunriseAndSunset": "Izlazak i zalazak sunca",
  "astral.sunriseAt": "Izlazak sunca u {time}",
  "astral.sunset": "Zalazak sunca",
  "astral.sunsetAt": "Zalazak sunca u {time}",
  "astral.thisYearAtNorth": "Ove godine na {degrees}° sjeverne širine",
  "astral.thisYearAtSouth": "Ove godine na {degrees}° južne širine",
  "astral.tonight": "Noćas",
  "astral.totalDaylight": "Ukupna obdanica",
  "astral.twilightAllNight": "Sumrak cijelu noć — nikad potpuno mračno",
  "astral.upFor": "{duration} iznad horizonta",
  "astral.usableLight": "Iskoristivo svjetlo",
  "astral.vsAverage": "{percent} od prosjeka",
  "astral.vsYesterday": "u odnosu na jučer",
  "astral.waningCrescent": "Opadajući srp",
  "astral.waningGibbous": "Opadajući mjesec",
  "astral.waxingCrescent": "Rastući srp",
  "astral.waxingGibbous": "Rastući mjesec",
  "astral.whereToLook": "Gdje gledati",
  "astral.withoutTheMoon": "{duration} bez Mjeseca",
  "auth.alreadyHaveAccount": "Već imate račun?",
  "auth.authContainerTagline": "Vaša osobna vremenska ploča. Povežite svoje postaje i dobijte podatke u stvarnom vremenu nadohvat ruke.",
  "auth.backToLogin": "Natrag na prijavu",
  "auth.catchPhrase": "Pametna platforma za praćenje vremenskih uvjeta",
  "auth.checkYourEmail": "Provjerite svoju e-poštu",
  "auth.continueWithApple": "Nastavite s Apple",
  "auth.continueWithFacebook": "Nastavite s Facebook",
  "auth.continueWithGoogle": "Nastavite s Google",
  "auth.email": "Adresa emaila",
  "auth.emailRequiredLoginFacebook": "Potrebna je potvrda putem emaila",
  "auth.emailVerification": "Potvrda e-pošte",
  "auth.emailVerificationFailure": "Došlo je do problema sa verifikacijom putem emaila.",
  "auth.emailVerificationSuccess": "Vaša email adresa je uspješno verificirana.",
  "auth.firstName": "Ime",
  "auth.forgotPassword": "Zaboravljena zaporka?",
  "auth.forgotPasswordSubtitle": "Unesite svoju e-poštu i poslat ćemo vam vezu za poništavanje zaporke.",
  "auth.lastName": "Prezime",
  "auth.login": "Prijava",
  "auth.loginSubtitle": "Dobrodošli natrag! Molimo unesite svoje podatke.",
  "auth.loginToSmartMixinDescription": "Unesite svoje SmartMixin vjerodajnice za pristup svom računu.",
  "auth.logout": "Odjava",
  "auth.logoutConfirmation": "Jeste li sigurni da želite prekinuti vezu?",
  "auth.noAccountYet": "Nemate još račun?",
  "auth.or": "ili",
  "auth.password": "Zaporka",
  "auth.passwordAgain": "Ponovite lozinku",
  "auth.passwordReset": "Reset lozinke",
  "auth.passwordResetSuccess": "Vaša zaporka je uspješno promijenjena.",
  "auth.register": "Kreiraj račun.",
  "auth.registerDescription": "Stvorite besplatni SmartMixin račun za povezivanje vaših meteoroloških postaja, praćenje vremenskih podataka i pristup naprednim analitičkim alatima.",
  "auth.registerSubtitle": "Izradite svoj račun za početak.",
  "auth.registerSuccess": "Uspješno ste se registrirali. Upravo smo vam poslali verifikacioni email na {emailAddress} sa detaljnim instrukcijama.",
  "auth.restorePassword": "Povrati lozinku",
  "auth.restorePasswordSuccess": "Upravo smo vam poslali link za reset lozinke na {emailAddress} sa detaljnim instrukcijama.",
  "auth.sendReset": "Pošalji instrukcije za reset",
  "auth.signInWithApple": "",
  "auth.socialAccount": "ili koristite vaš račun",
  "auth.welcome": "Dobrodošli u Smartmixin",
  "auth.welcomeBack": "Dobrodošli natrag!",
  "calendar.april": "Travanj",
  "calendar.august": "Kolovoz",
  "calendar.dateFormat": "Oblik datuma",
  "calendar.day": "Dan",
  "calendar.december": "Prosinac",
  "calendar.end": "Kraj",
  "calendar.february": "Veljača",
  "calendar.hours": "Sati",
  "calendar.hoursShort": "sati",
  "calendar.january": "Siječanj",
  "calendar.july": "Srpanj",
  "calendar.june": "Lipanj",
  "calendar.last24Hours": "zadnja 24 sata",
  "calendar.last30Days": "posljednjih 30 dana",
  "calendar.last7Days": "posljednjih 7 dana",
  "calendar.march": "Ožujak",
  "calendar.max": "Max",
  "calendar.may": "Svibanj",
  "calendar.month": "Mjesec",
  "calendar.months": "Mjeseci",
  "calendar.november": "Studeni",
  "calendar.october": "Listopad",
  "calendar.oneDay": "1-dan",
  "calendar.oneHour": "1-sat",
  "calendar.oneMonth": "1-mjesec",
  "calendar.oneWeek": "1-tjedan",
  "calendar.previous24Hours": "Prethodna 24 sata",
  "calendar.previous30Days": "Prethodnih 30 dana",
  "calendar.previous7Days": "Prethodnih 7 dana",
  "calendar.previousDay": "Prethodni dan",
  "calendar.previousMonth": "Prethodni mjesec",
  "calendar.previousWeek": "Prethodni tjedan",
  "calendar.previousYear": "Prethodnu godinu",
  "calendar.sameDayLastYear": "Na isti dan prethodne godine",
  "calendar.sameMonthLastYear": "Tokom istog mjeseca prethodne godine",
  "calendar.selectADate": "Odaberite datum",
  "calendar.selectAggregation": "Odaberite prikazanu vrijednost",
  "calendar.selectAMonth": "Odaberite mjesec dana",
  "calendar.selectAYear": "Odaberite godinu dana",
  "calendar.selectGranularity": "Izaberi preciznost",
  "calendar.selectTimescale": "Izaberi vremensku skalu",
  "calendar.september": "Rujan",
  "calendar.sixHours": "6-sati",
  "calendar.start": "Početak",
  "calendar.thirtyMinutes": "30-minuta",
  "calendar.threeHours": "3-sata",
  "calendar.use24HourFormat": "Koristite 24-satni format",
  "calendar.week": "Tjedan",
  "calendar.year": "Godina",
  "calendar.yesterday": "Jučer",
  "common.accountDeleted": "Vaš račun je uspješno izbrisan.",
  "common.accountOnHold": "Veza vašeg računa je istekla. Ponovno se povežite za nastavak ažuriranja podataka.",
  "common.add": "Dodati",
  "common.addAStation": "Dodaj stanicu",
  "common.addToFavorites": "Dodaj u favorite",
  "common.addYourOwnStation": "Dodajte vlastitu stanicu",
  "common.afternoon": "Poslijepodne",
  "common.alreadyPremium": "Već imate Premium račun!",
  "common.alsoAvailableOn": "Dostupno i na:",
  "common.altitude": "Nadmorska visina",
  "common.analysis": "Analiza",
  "common.aroundMe": "U mojoj blizini",
  "common.articleCount": "{count, plural, one {# članak} few {# članka} other {# članaka}}",
  "common.articleNotFound": "Članak nije pronađen",
  "common.articleNotFoundDescription": "Članak koji tražite ne postoji.",
  "common.average": "Prosjek",
  "common.averageOverThePeriod": "Prosjek tokom perioda",
  "common.away": "Odsutnost",
  "common.back": "Natrag",
  "common.backToHelpCenter": "Natrag u centar za pomoć",
  "common.backToHome": "Natrag na Početnu",
  "common.bad": "Loše",
  "common.batteryLevel": "Razina baterije",
  "common.bestValue": "Najbolja Vrijednost",
  "common.billingDetailsAndroid": "Besplatna probna verzija vam neće biti naplaćena ukoliko odustanete 24 sata prije isteka probnog perioda. Kada probni period završi, možete da otkažete Smartmixin pretplatu u bilo kom trenutku preko Google Playa, a u suprotnom će pretplata automatski da se obnovi. Ovo morate da uradite barem 24 sata prije isteka probnog perioda kako biste izbjegli naplatu za još jedan period u iznosu naznačenom na gumbu. Plaćanje pretplate biti će obavljeno kroz Google Play kada potvrdite kupnju i nakon ispunjenja uvjeta za obnavljanje pretplate za svaki sljedeći period.",
  "common.billingDetailsIos": "Besplatna probna verzija vam neće biti naplaćena ukoliko odustanete 24 sata prije isteka probnog perioda. Kada probni period završi, možete da otkažete Smartmixin pretplatu u bilo kom trenutku preko App store aplikacije, a u suprotnom će pretplata automatski da se obnovi. Ovo morate da uradite barem 24 sata prije isteka probnog perioda kako biste izbjegli naplatu za još jedan period u iznosu naznačenom na gumbu. Plaćanje pretplate biti će obavljeno kroz vašu App store aplikaciju kada potvrdite kupnju i nakon ispunjenja uvjeta za obnavljanje pretplate za svaki sljedeći period.",
  "common.boilerOn": "Bojler UKLJUČEN",
  "common.browseByCategory": "Pregledaj po kategoriji",
  "common.calendarView": "Kalendarski pregled",
  "common.cancel": "Otkaži",
  "common.cannotBeEmpty": "Ovo polje ne može biti prazno.",
  "common.cardDetails": "Podaci o kartici",
  "common.categoryNotFound": "Kategorija nije pronađena",
  "common.categoryNotFoundDescription": "Ova kategorija ne postoji ili nema članaka.",
  "common.charts": "Dijagrami",
  "common.chartView": "Pregled dijagrama",
  "common.clearRecentLocations": "Očisti sve",
  "common.close": "Zatvori",
  "common.comparison": "Usporedbe",
  "common.contactMe": "Kontaktirajte me",
  "common.currentDay": "Danas",
  "common.currentLocation": "Trenutno mjesto",
  "common.currentObservations": "Trenutne vrijednosti",
  "common.currentRainEvent": "Trenutačni kišni događaj",
  "common.currentRate": "Intenzitet kiše",
  "common.currentWeatherConditions": "Trenutni uvjeti",
  "common.customizeComparisonMetrics": "Prilagodi mjerne podatke usporedbe",
  "common.customizeComparisonMetricsDescription": "Povucite stavke za promjenu redoslijeda mjernih podataka usporedbe. Dodirnite ikonu oka za prikaz ili skrivanje mjernih podataka.",
  "common.customizeDashboard": "Prilagodi",
  "common.customizeDashboardDescription": "Povucite stavke za promjenu redoslijeda na nadzornoj ploči. Dodirnite ikonu oka za prikaz ili skrivanje odjeljaka.",
  "common.customizedStationName": "Naziv prilagođene stanice",
  "common.dailyForecast": "Dnevna prognoza",
  "common.dashboard": "Nadzorna ploča",
  "common.default": "Zadano",
  "common.defaultForecastModelChip": "Zadano · {name}",
  "common.delete": "Izbrisati",
  "common.deleteAccount": "Izbriši račun",
  "common.deleteAccountConfirmation": "Jeste li sigurni da želite izbrisati svoj račun? Ova radnja je nepovratna.",
  "common.deleteAccountDescription": "Ova radnja briše vaš račun i sve vaše podatke. Nema povratka.",
  "common.details": "Detalji",
  "common.durationHours": "{hours} h",
  "common.durationHoursMinutes": "{hours} h {minutes} min",
  "common.durationMinutes": "{minutes} min",
  "common.durationMinutesSeconds": "{minutes} min {seconds} s",
  "common.durationSeconds": "{seconds} s",
  "common.edit": "Uredi",
  "common.editor": "Uređivač",
  "common.endTime": "Kraj",
  "common.evening": "Večer",
  "common.exitFullscreen": "Izađi iz cijelog zaslona",
  "common.exploreWeatherMap": "Istraži Vremensku Kartu",
  "common.favoriteLocations": "Favoriti",
  "common.favoriteLocationsEmpty": "Možete dodati do 5 omiljenih lokacija.",
  "common.favoriteStations": "Omiljene stanice",
  "common.feedbackHelpsImprove": "Vaše povratne informacije pomažu nam poboljšati članke pomoći.",
  "common.feedbackReasonNotAnswer": "Ne odgovara na moje pitanje",
  "common.feedbackReasonOutdated": "Informacije su zastarjele",
  "common.feedbackReasonUnclear": "Upute su nejasne",
  "common.feedbackWhatWentWrong": "U čemu je bio problem?",
  "common.filterStationDescription": "Ne prikazuj stanice sa nepouzdanim mjerenjima.",
  "common.filterStations": "Filtriraj stanice",
  "common.filterStationSourceDescription": "Odaberite pružatelje postaja koje želite prikazati na karti",
  "common.findStationsNearYou": "Pronađi stanice u blizini",
  "common.firmwareVersion": "Verzija firmwarea",
  "common.forecast": "Prognoza",
  "common.forecastAllModels": "Svi modeli ({count})",
  "common.forecastComparisonDescription": "Jednostavno usporedite podatke iz različitih dostupnih vremenskih modela",
  "common.forecastFollowingPreferences": "Prema vašim postavkama",
  "common.forecastModelComparison": "Usporedba vremenskih modela",
  "common.forecastModelCoverage": "Pokrivenost",
  "common.forecastModelDescription": "Opis",
  "common.forecastModelDescription_AROME": "Visokorezolucijski model Météo Francea koji omogućava razlučivanje konvekcije nad zapadnom Europom s rezolucijom od 1,3 km. Najbolji u klasi za kratkoročne prognoze u Francuskoj; ažurira se svaka tri sata.",
  "common.forecastModelDescription_ARPEGE_EU": "Europsko gnijezdo modela ARPEGE Météo Francea s rezolucijom od 10 km. Srednjoročne prognoze nad Europom, ažuriraju se četiri puta dnevno.",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "Globalni numerički model vremena Météo Francea s rezolucijom od 25 km, do otprilike 4 dana. Ažurira se četiri puta dnevno.",
  "common.forecastModelDescription_DMI_DINI": "HARMONIE DINI tvrtke DMI: model koji omogućuje konvekciju nad sjeverozapadnom Europom — Danska, Beneluks, Irska, Ujedinjeno Kraljevstvo i Skandinavija — s rezolucijom od 2 km koji ide do 60 sati, ažurira se osam puta dnevno. Sadrži izmijenjene otvorene podatke DMI-ja (CC BY 4.0).",
  "common.forecastModelDescription_EC_GDPS": "Globalni deterministički sustav predviđanja Environment Canada: svjetski srednjoročni model s rezolucijom od 15 km koji ide do 10 dana, ažurira se dva puta dnevno.",
  "common.forecastModelDescription_EC_HRDPS": "Deterministički sustav predviđanja visoke rezolucije Environment Canada: model koji omogućuje konvekciju nad Kanadom i sjevernim dijelom Sjedinjenih Država s rezolucijom od 2,5 km koji ide do 48 sati, ažurira se četiri puta dnevno.",
  "common.forecastModelDescription_EC_RDPS": "Regionalni deterministički sustav predviđanja Environment Canada: srednjoročni model nad Sjevernom Amerikom s rezolucijom od 10 km, ažurira se četiri puta dnevno.",
  "common.forecastModelDescription_ECMWF_HRES": "Vodeći model visoke rezolucije (IFS) Europskog centra za srednjoročne vremenske prognoze, široko smatran najboljim globalnim prognostičkim sustavom na svijetu. Pokriva cijeli planet rezolucijom od 25 km do 15 dana, ažurira se četiri puta dnevno. Sadrži izmijenjene otvorene podatke ECMWF-a (CC BY 4.0).",
  "common.forecastModelDescription_GFS": "NOAA-in vodeći srednjoročni globalni model. Pokriva cijeli planet s rezolucijom od 25 km do 16 dana, ažurira se četiri puta dnevno.",
  "common.forecastModelDescription_HRRR_CONUS": "NOAA-in High-Resolution Rapid Refresh: model koji omogućava razlučivanje konvekcije nad kontinentalnim SAD-om s rezolucijom od 3 km, ažurira se svaki sat. Najprikladniji za vrlo kratkoročne prognoze grmljavinskih oluja i jakog vremena.",
  "common.forecastModelDescription_ICON": "DWD-ov globalni model ICON razlučivosti 13 km koji pokriva cijeli planet do 7,5 dana, ažurira se četiri puta dnevno. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_2I": "ICON-2I agencije ItaliaMeteo, koji se izvodi zajedno s ARPAE: model koji omogućuje konvekciju nad Italijom s rezolucijom od 2,2 km koji ide do 72 sata, ažurira se dvaput dnevno. Sadrži otvorene podatke ItaliaMeteo (CC BY 4.0).",
  "common.forecastModelDescription_ICON_CH1": "Kontrolno izvođenje modela ICON-CH1-EPS agencije MeteoSwiss: model koji omogućuje konvekciju nad Alpama s rezolucijom od 1 km koji ide do 33 sata, ažurira se svaka tri sata.",
  "common.forecastModelDescription_ICON_CH2": "Kontrolno izvođenje modela ICON-CH2-EPS agencije MeteoSwiss: model koji omogućuje konvekciju nad Alpama — Švicarska i okolna alpska regija — s rezolucijom od 2,1 km koji ide do 120 sati, ažurira se četiri puta dnevno.",
  "common.forecastModelDescription_ICON_DE": "Visokorezolucijski model DWD-a koji omogućava razlučivanje konvekcije nad Njemačkom i susjednim zemljama s rezolucijom od 2,2 km. Kratkoročne prognoze ažuriraju se dva puta dnevno. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_EU": "Europsko gnijezdo modela ICON DWD-a s rezolucijom od 7 km koje pokriva Europu i Sjeverni Atlantik. Srednjoročne prognoze ažuriraju se četiri puta dnevno. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_MET_NORWAY": "Otvorena usluga prognoze vremena Norveškog meteorološkog instituta, koja kombinira visokorezolucijske nordijske modele s podacima ECMWF-a za pružanje globalnih prognoza do 10 dana unaprijed.",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "Gnijezdo AROME nad francuskim Antilima (Guadeloupe, Martinique) s rezolucijom od 2,5 km. Kratkoročne prognoze ažuriraju se četiri puta dnevno.",
  "common.forecastModelDescription_MF_AROME_GUYANE": "Gnijezdo AROME nad Francuskom Gvajanom s rezolucijom od 2,5 km. Kratkoročne prognoze ažuriraju se četiri puta dnevno.",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "Gnijezdo AROME nad Novom Kaledonijom s rezolucijom od 2,5 km. Kratkoročne prognoze ažuriraju se četiri puta dnevno.",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "Gnijezdo AROME nad Francuskom Polinezijom s rezolucijom od 2,5 km. Kratkoročne prognoze ažuriraju se četiri puta dnevno.",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "Gnijezdo AROME nad Réunionom i Mayotteom s rezolucijom od 2,5 km. Kratkoročne prognoze ažuriraju se četiri puta dnevno.",
  "common.forecastModelDescription_NAM_CONUS": "Gnijezdo NOAA-inog North American Mesoscale modela nad kontinentalnim SAD-om s rezolucijom od 5 km. Kratkoročne prognoze ažuriraju se četiri puta dnevno.",
  "common.forecastModelDescription_NAM_NORTH_AMERICA": "NOAA-in North American Mesoscale model koji pokriva cijelu Sjevernu Ameriku s rezolucijom od 32 km. Ažurira se četiri puta dnevno.",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "Vodeća prognoza SmartMixina. Za svaki sat na vašoj lokaciji biramo najbolji dostupan model — obično visokorezolucijski regionalni model gdje takav postoji (AROME u Francuskoj, ICON-D2 u Njemačkoj, HRRR u SAD-u, ARPEGE Europe na cijelom kontinentu…) i vraćamo se na globalni model drugdje — zatim popunjavamo sve praznine iz susjednih izvora. Rezultat je jedna besprijekorna prognoza koja pokriva bilo gdje u svijetu do 14 dana, automatski se ažurira svaki put kada se ažurira bilo koji od osnovnih modela.",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "Vlasnička globalna prognoza Weatherflowa koja spaja više numeričkih modela vremena s opažanjima iz njegove mreže Tempest meteoroloških stanica. Svjetski horizont od 10 dana.",
  "common.forecastModelDetailTitle": "Prognostički model",
  "common.forecastModelScopeGlobal": "Globalni",
  "common.forecastModelScopeGlobalDescription": "Ovaj model pokriva cijeli planet.",
  "common.forecastModelScopeRegional": "Regionalni",
  "common.forecastModelScopeRegionalDescription": "Ovaj model pokriva samo određenu regiju.",
  "common.forecastModelSpecifications": "Specifikacije",
  "common.forecastNoPinLocation": "Nijedan preferirani model ne doseže ovu lokaciju — odlučuje „svugdje drugdje”.",
  "common.forecastNoPinStation": "Nijedan preferirani model ne doseže ovu stanicu — odlučuje „svugdje drugdje”.",
  "common.forecastNoPreferredModels": "Još nema postavljenih preferiranih modela.",
  "common.forecastOverrideElsewhere": "Vaše postavke vrijede svugdje drugdje.",
  "common.forecastPickForLocation": "Ili odaberite jedan za ovu lokaciju",
  "common.forecastPickForStation": "Ili odaberite jedan za ovu stanicu",
  "common.forecastPinWinsLocation": "{model} — vaš prvi preferirani model koji doseže ovu lokaciju.",
  "common.forecastPinWinsStation": "{model} — vaš prvi preferirani model koji doseže ovu stanicu.",
  "common.forecastServedNowHere": "Trenutačno je ovdje {model}",
  "common.forecastSetForLocation": "Postavljeno za ovu lokaciju",
  "common.forecastSetForStation": "Postavljeno za ovu stanicu",
  "common.forecastSettingsRowSub": "Preferirani modeli i što vrijedi svugdje drugdje",
  "common.forecastSheetTitle": "Model prognoze",
  "common.forecastSources": "Izvori prognoze",
  "common.forecastStopUsingHere": "Prestani koristiti ovdje",
  "common.forecastUseForLocation": "Koristi {model} za ovu lokaciju",
  "common.forecastUseForStation": "Koristi {model} za ovu stanicu",
  "common.forecastUsePreferred": "Koristi moje preferirane modele",
  "common.freeAccount": "Besplatni račun",
  "common.freeSubscription": "Besplatna pretplata",
  "common.freeTrialForPeriod": "Besplatni nalog u trajanju od {period} dana",
  "common.frequency": "Frekvencija",
  "common.full": "Pun",
  "common.fullscreen": "Cijeli zaslon",
  "common.getStartedFree": "Započni Besplatno",
  "common.getUnlimitedAccess": "Neograničen pristup:",
  "common.good": "Dobro",
  "common.hail": "Tuča",
  "common.help": "Pomoć",
  "common.helpCategoryAccount": "Račun",
  "common.helpCategoryBilling": "Naplata",
  "common.helpCategoryForecast": "Prognoze",
  "common.helpCategoryGettingStarted": "Prvi koraci",
  "common.helpCategoryProviders": "Pružatelji",
  "common.helpCategoryStations": "Stanice",
  "common.helpCategoryTroubleshooting": "Rješavanje problema",
  "common.helpCenter": "Centar za pomoć",
  "common.helpCenterDescription": "Pronađite odgovore na česta pitanja i saznajte kako izvući najbolje iz SmartMixina.",
  "common.hg": "Zaštita od mraza",
  "common.hidden": "Skriveno",
  "common.hiddenSensors": "Skriveni senzori",
  "common.hiddenStations": "Skrivene stanice",
  "common.hiddenStationsDescription": "Stanicu možete ukloniti tako što dodirnete ikonu oka pokraj nje.",
  "common.high": "Visoko",
  "common.home": "Kuća",
  "common.homeConnectService": "Posjedujete meteorološku postaju? Povežite svoj servis",
  "common.homeInformation": "Kućne informacije",
  "common.homeIntroduction": "Povežite vaše vanjske račune kako biste uživali u mogućnostima programa Smartmixin.",
  "common.homeName": "Ime kuće",
  "common.homeSubtitle": "Vaše vrijeme, sve na jednom mjestu",
  "common.horizon": "Horizont",
  "common.horizonValue": "do {value} sati",
  "common.hour": "Sat",
  "common.iDontKnowYet": "Još ne znam",
  "common.indoor": "Unutra",
  "common.lastRainEvent": "Zadnji kišni događaj",
  "common.lastUpdate": "Poslijednja provjera",
  "common.legendHeavy": "Jak",
  "common.legendLight": "Slab",
  "common.legendLightningHelp": "Boja prikazuje starost svake munje u posljednjih {minutes} minuta — najnovije bijelom, najstarije tamnocrvenom.",
  "common.legendNewest": "Najnovije",
  "common.legendOldest": "Najstarije",
  "common.legendStationsHelp": "Boja oznake odražava vrijednost odabrane veličine.",
  "common.lightningDataAttribution": "Podaci o munjama: Blitzortung.org",
  "common.lightningStrikes": "Udari munja",
  "common.lightningStrikesDescription": "Prikaži udare munja u stvarnom vremenu na karti",
  "common.linkToSection": "Poveznica na ovaj odjeljak",
  "common.loading": "Učitavam",
  "common.location": "Lokacija",
  "common.locationAddedToFavorites": "Lokacija dodana favoritima",
  "common.locationNotGranted": "Dozvola za lokaciju nije odobreno. Dopustite pristup svojoj lokaciji u postavkama uređaja.",
  "common.locationRemovedFromFavorites": "Lokacija uklonjena iz favorita",
  "common.locations": "Lokacija",
  "common.low": "Nisko",
  "common.manage": "Upravljaj",
  "common.manageAccount": "Upravljaj računom",
  "common.manageMySubscription": "Upravljaj pretplatom",
  "common.manageSensors": "Upravljanje senzorima",
  "common.manageSensorsDescription": "Povucite stavke za promjenu redoslijeda senzora. Dodirnite ikonu oka za prikaz ili skrivanje senzora. Dodirnite naziv za preimenovanje.",
  "common.manualBoost": "Ručno povećanje",
  "common.manualSetpointUntil": "Postavi ručno točku do",
  "common.mapLayers": "Slojevi karte",
  "common.mapLegend": "Legenda karte",
  "common.maxFavoriteLocationsReached": "Možete imati samo do 5 omiljenih lokacija. Uklonite jedan da biste dodali drugi.",
  "common.maximum": "Maksimum",
  "common.maxOverThePeriod": "Maksimum tokom perioda",
  "common.measureToDisplay": "Mjera za prikaz",
  "common.medium": "Srednje",
  "common.meshSize": "Veličina mreže",
  "common.minimum": "Minimum",
  "common.minRead": "{minutes} min čitanja",
  "common.modifyFavoriteStations": "Izmijenite omiljene stanice",
  "common.modifyFavoriteStationsDescription": "Svoje omiljene stanice možete naručiti tako da ih povučete. Također ih možete ukloniti s popisa.",
  "common.moduleType": "Tip modula",
  "common.monthTotal": "Ovaj mjesec",
  "common.more": "Više",
  "common.moreInformation": "Više informacija",
  "common.morning": "Jutro",
  "common.myLocation": "Moja lokacija",
  "common.nearbyWeatherStations": "Obližnje meteorološke stanice",
  "common.next": "Sljedeći",
  "common.nextHours": "Sljedeći sati",
  "common.night": "Noć",
  "common.no": "Ne",
  "common.noAccountNeeded": "Nije potreban račun",
  "common.noDataForThisPeriod": "Nema podataka u periodu",
  "common.noLocationsFound": "Nije pronađena nijedna lokacija",
  "common.noNetatmoWeatherStationYet": "Još uvijek nemate Netatmo Weather.",
  "common.noOutdoorModule": "Nije otkriven niti jedan vanjski modul za ovu stanicu.",
  "common.noSearchResults": "Nijedan članak ne odgovara vašem pretraživanju",
  "common.noStationsFound": "Nisu pronađene stanice",
  "common.noThermostatYet": "Nemate termostat.",
  "common.notNow": "Ne sada",
  "common.notPurchasedYet": "Čini se da ovaj proizvod još uvijek niste kupili.",
  "common.now": "Sada",
  "common.noWeatherStation": "Nemate meteorološku stanicu",
  "common.noWeatherStationYet": "Još uvijek nemate meteorološku stanicu",
  "common.numberOfActiveWarnings": "{warning_count} aktivnih vremenskih upozorenja",
  "common.onThisPage": "Na ovoj stranici",
  "common.openSettings": "Otvorene postavke",
  "common.orChooseMonthly": "Ili odaberi mjesečno:",
  "common.outdatedModule": "Podaci sa ovog modula nisu ažurni.",
  "common.outdoor": "Vani",
  "common.outdoorTemperature": "Vanjska temperatura",
  "common.pageNotFound": "Stranica Nije Pronađena",
  "common.pageNotFoundDescription": "Stranica koju tražite ne postoji ili je premještena.",
  "common.passwordUpdated": "Lozinka je uspješno promijenjena.",
  "common.personalWeatherIntelligence": "Vaša Osobna Vremenska Inteligencija",
  "common.platformMobileApp": "Mobilna aplikacija",
  "common.platformMobileOnly": "Samo u mobilnoj aplikaciji",
  "common.platformWebApp": "Web-aplikacija",
  "common.platformWebOnly": "Samo u web-aplikaciji",
  "common.popularArticles": "Popularni članci",
  "common.premiumAccount": "Premium račun",
  "common.premiumDescription": "Premium račun otključava veliki broj dodatnih mogućnosti poput napredne analize vremena, usporednih dijagrama, lokalnih prognostičkih modela i još mnogo toga.",
  "common.premiumFeatureAlerts": "Vremenska Upozorenja",
  "common.premiumFeatureAnalysis": "Napredna Analiza Vremena",
  "common.premiumFeatureCharts": "Usporedbe Grafova",
  "common.premiumFeatureExport": "Izvoz Podataka",
  "common.premiumFeatureForecast": "Regionalni Prognostički Modeli",
  "common.premiumFeatureNotification": "Widget Statusne Trake",
  "common.premiumFeatureTitle": "Premium Značajka",
  "common.premiumFeatureWidgets": "Widgeti početnog zaslona",
  "common.pressureSummary": "Sinteza tlaka",
  "common.previous": "Prethodni",
  "common.previousHours": "Prethodni sati",
  "common.profileUpdated": "Profil je uspješno promijenjen.",
  "common.purchasedNetatmoPro": "Prethodno ste kupili Netatmo Pro ({date}). Pretplatite se na jednu od ponuda u nastavku kako biste imali pristup svim premium značajkama aplikacije.",
  "common.radarDataAttribution": "Podaci radara: NOAA / EUMETNET OPERA via LibreWXR",
  "common.rain": "Kiša",
  "common.rainEvents": "Kišni događaji",
  "common.rainfallMeasurement": "Mjerenje količine oborina",
  "common.rainRadar": "Radar oborina",
  "common.rainRadarDescription": "Prikaz kišnog radara na karti",
  "common.rainSummary": "Rezime padalina",
  "common.range": "Interval",
  "common.recentLocations": "Nedavni",
  "common.recentLocationsEmpty": "Vi nedavna povijest je prazna.",
  "common.recentStations": "Nedavne stanice",
  "common.relatedArticles": "Povezani članci",
  "common.relay": "Relej",
  "common.removeFromFavorites": "Ukloni iz omiljenih",
  "common.renameSensors": "Promjena naziva senzora",
  "common.resetZoom": "Resetuj zoom",
  "common.restorePurchase": "Obnovi kupnju",
  "common.room": "Prostorija",
  "common.rooms": "Prostorije",
  "common.savingsPercent": "Uštedite {percent}%",
  "common.searchArticles": "Pretraži članke...",
  "common.searchForALocation": "Traži lokaciju...",
  "common.searchForLocation": "Potraži lokaciju",
  "common.searchForWeatherStation": "Potraži stanicu",
  "common.searchResults": "Rezultati pretraživanja",
  "common.searchResultsEmpty": "Nisu pronađeni rezultati.",
  "common.searchResultsFound": "{count, plural, one {Pronađen # rezultat} few {Pronađena # rezultata} other {Pronađeno # rezultata}}",
  "common.searchStationsDescription": "Unesite grad, adresu ili naziv mjesta kako biste pronašli meteorološke stanice u blizini.",
  "common.searchStationsHint": "Koristite traku za pretraživanje iznad kako biste otkrili meteorološke stanice bilo gdje u svijetu.",
  "common.selectStationForComparison": "Odaberite stanicu za usporedbu",
  "common.selectWeatherForecastProvider": "Izaberite dobavljača vremenske prognoze",
  "common.serialNumber": "Serijski broj",
  "common.share": "Podijeli",
  "common.shareOutdoorMeasures": "Podijelite vaša vanjska mjerenja",
  "common.shareOutdoorMeasuresDescription": "Učestvujte u zajednici korisnika aplikacije SmartMixin tako što ćete dijeliti mjerenja sa vašeg vanjskog modula. Mjerenja sa unutrašnjeg modula nikada neće biti dijeljena.",
  "common.shareYourWeather": "Podijelite vaše vremenske uvjete",
  "common.signalStrength": "Jačina signala",
  "common.skip": "Preskočiti",
  "common.smartThermostat": "Pametni termostat",
  "common.smartValve": "Pametni ventil",
  "common.snow": "Snijeg",
  "common.start": "Start",
  "common.startFreeTrial": "Započnite Besplatno Probno Razdoblje",
  "common.startTime": "Početak",
  "common.station": "stanica",
  "common.stationAddedToFavorites": "Stanica je dodana u omiljene",
  "common.stationComparison": "Usporedba stanica",
  "common.stationComparisonDescription": "Omogućuje vam usporedbu povijesnih vremenskih podataka s podacima druge postaje.",
  "common.stationInformation": "Informacije o stanici",
  "common.stationName": "Naziv stanice",
  "common.stationObservationsDescription": "Prikaži najnovija opažanja meteoroloških stanica",
  "common.stationRemovedFromFavorites": "Stanica je uklonjena iz omiljenih",
  "common.stations": "stanice",
  "common.stationsNear": "Stanice u blizini",
  "common.stationType": "tip stanice",
  "common.statusOffline": "Izvan mreže",
  "common.statusOnline": "Na mreži",
  "common.statusStale": "Zastarjelo",
  "common.statusSyncing": "Sinkronizacija",
  "common.stillNeedHelp": "Još uvijek trebate pomoć?",
  "common.stillNeedHelpDescription": "Ako ovaj članak nije odgovorio na vaše pitanje, rado ću vam pomoći izravno.",
  "common.subscribeNow": "Pretplati se sada - bez probe",
  "common.sumOverThePeriod": "Akumulirano tokom perioda",
  "common.switchToPremium": "Pređi na SmartMixin Premium",
  "common.temperatureShort": "Temp.",
  "common.temperatureSummary": "Sažetak temperature",
  "common.thankYouForFeedback": "Hvala na povratnoj informaciji!",
  "common.thenPrice": "zatim {price}",
  "common.timeSelection": "Izbor perioda",
  "common.timezone": "Vremenska zona",
  "common.totalDuration": "Ukupno trajanje",
  "common.tryAnotherLocation": "Nismo mogli pronaći meteorološke stanice u blizini ove lokacije. Pokušajte pretraživati u drugom području.",
  "common.unknown": "Nepoznat",
  "common.untilChanged": "Do promjene",
  "common.untilTime": "do {time}",
  "common.updateAvailable": "Dostupno je ažuriranje",
  "common.updateAvailableOpenAppStore": "Dodirnite za otvaranje App Storea",
  "common.updateAvailableOpenGooglePlay": "Dodirnite za otvaranje Google Playa",
  "common.updateAvailableVersion": "Dostupno je ažuriranje: v{version}",
  "common.upgrade": "Nadogradi",
  "common.upgradeRequiredAndroid": "Potrebna je nadogradnja aplikacije. Posjetite Google Play radi nadogradnje.",
  "common.upgradeRequiredIos": "Potrebna je nadogradnja aplikacije. Idite u vašu App store aplikaciju radi nadogradnje.",
  "common.validate": "Potvrdi",
  "common.validEmail": "Potrebna je važeća email adresa.",
  "common.very_low": "Veoma nisko",
  "common.viewAsList": "Popis",
  "common.viewAsPeriods": "Razdoblja",
  "common.visitNetatmoWebsite": "Posjetite stranicu Netatmo",
  "common.wasArticleHelpful": "Je li vam ovaj članak bio koristan?",
  "common.weatherCondition": "Vremenski uvjeti",
  "common.weatherflowNCRain": "NC rain (Nearcast Rain)",
  "common.weatherflowNCRainDescription": "NC Rain dodatni je izvor podataka putem Tempest Weather Systema, kojeg pokreće Nearcast Technology. Podaci o NC rain procjena su prosječne akumulacije oborina oko vaše oluje na razini susjedstva",
  "common.weatherForecastModels": "Modeli vremenske prognoze",
  "common.weatherIntelligencePlatform": "Platforma Vremenske Inteligencije",
  "common.weatherMap": "Meteokarta",
  "common.weatherMapMetaDescription": "SmartMixin nudi interaktivne karte vremena i radara za vremenske uvjete diljem svijeta.",
  "common.weatherObservations": "Promatranja vremena",
  "common.weatherStation": "Meteostanica",
  "common.weatherStations": "Meteostanice",
  "common.welcome": "Dobrodošli u Smartmixin!",
  "common.whenBackHome": "Kad se vraćate doma?",
  "common.wifiStrength": "Jačina WiFi signala",
  "common.wind": "Vjetar",
  "common.windMeasurement": "Mjerenje vjetra",
  "common.windSpeed": "Brzina vjetra",
  "common.windSummary": "Sinteza vjetra",
  "common.yearToDate": "Ove godine",
  "common.yes": "Da",
  "common.zoomImage": "Povećaj sliku",
  "forecastMaps.addColor": "Dodaj boju",
  "forecastMaps.addLayer": "Dodaj sloj",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.backToMaps": "Natrag na karte",
  "forecastMaps.browseMaps": "Pregledaj karte",
  "forecastMaps.build": "Generiraj",
  "forecastMaps.buildCompleted": "Generiranje dovršeno",
  "forecastMaps.builderMetaDescription": "Sastavite vlastite prognostičke karte od slojeva meteoroloških modela.",
  "forecastMaps.builderTitle": "Izrada karata",
  "forecastMaps.buildFailed": "Generiranje nije uspjelo. Pokušajte ponovno.",
  "forecastMaps.buildNotPossible": "Ova se karta još ne može generirati — nema dostupnih prognostičkih podataka.",
  "forecastMaps.buildProgress": "Iscrtavanje… {completed}/{total} koraka",
  "forecastMaps.buildStarting": "Pokretanje generiranja…",
  "forecastMaps.byModel": "Po modelu",
  "forecastMaps.byZone": "Po zoni",
  "forecastMaps.colormap": "Paleta boja",
  "forecastMaps.colormapCustom": "Prilagođene boje",
  "forecastMaps.colormapGroupDomain": "Meteorološke predloške",
  "forecastMaps.colormapGroupMatplotlib": "Znanstvene predloške",
  "forecastMaps.colorScale": "Skala boja",
  "forecastMaps.comingSoon": "Ovaj prikaz uskoro stiže.",
  "forecastMaps.contourLevels": "Razine izolinija",
  "forecastMaps.countryCanada": "Kanada",
  "forecastMaps.countryFrance": "Francuska",
  "forecastMaps.countryGermany": "Njemačka",
  "forecastMaps.countryItaly": "Italija",
  "forecastMaps.countryScandinavia": "Skandinavija",
  "forecastMaps.countrySpain": "Španjolska",
  "forecastMaps.countrySwitzerland": "Švicarska",
  "forecastMaps.countryUnitedStates": "Sjedinjene Države",
  "forecastMaps.customColormapMinColors": "Prilagođena paleta boja zahtijeva najmanje dvije boje",
  "forecastMaps.customExtent": "Prilagođeni obuhvat",
  "forecastMaps.deleteMap": "Izbriši kartu",
  "forecastMaps.deleteMapBody": "„{name}” i njezina iscrtavanja bit će trajno izbrisani.",
  "forecastMaps.deleteMapTitle": "Izbrisati ovu kartu?",
  "forecastMaps.displayName": "Prikazani naziv",
  "forecastMaps.downloadMp4": "Preuzmi MP4",
  "forecastMaps.downscaling": "Faktor prorjeđivanja vjetrovnih zastavica",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Nacrtaj područje",
  "forecastMaps.east": "Istok",
  "forecastMaps.editMap": "Uredi kartu",
  "forecastMaps.exportBuilding": "Priprema videozapisa…",
  "forecastMaps.exportError": "Izvoz videozapisa nije uspio. Pokušajte ponovno.",
  "forecastMaps.exportMp4": "Izvezi MP4",
  "forecastMaps.exportNotReady": "Videozapis još nije spreman. Pokušajte ponovno kasnije.",
  "forecastMaps.extentDrawHint": "Povucite po karti da biste nacrtali područje",
  "forecastMaps.extentInvalid": "Zapad mora biti manji od istoka, a jug manji od sjevera",
  "forecastMaps.extentPanZoomHint": "Pomičite i zumirajte dok područje ne ispuni okvir",
  "forecastMaps.flipbookView": "Animacija",
  "forecastMaps.forecastModel": "Prognostički model",
  "forecastMaps.forkAndEdit": "Dupliciraj i uredi",
  "forecastMaps.height": "Visina (inči)",
  "forecastMaps.hourOffset": "+{hour} h",
  "forecastMaps.invalidHexColor": "Nevažeća boja — koristite #RRGGBB",
  "forecastMaps.layers": "Slojevi",
  "forecastMaps.layerTypeBarbs": "Vjetrovne zastavice",
  "forecastMaps.layerTypeContour": "Izolinije",
  "forecastMaps.layerTypeFilledContour": "Ispunjene izolinije",
  "forecastMaps.layerTypeMagnitude": "Magnituda",
  "forecastMaps.layerTypeRaster": "Raster",
  "forecastMaps.layerTypeVectorField": "Vektorsko polje",
  "forecastMaps.leave": "Izađi",
  "forecastMaps.levelsCount": "Broj",
  "forecastMaps.levelsInvalid": "Nevažeće razine izolinija",
  "forecastMaps.levelsModeArange": "Fiksni korak",
  "forecastMaps.levelsModeExplicit": "Eksplicitne vrijednosti",
  "forecastMaps.levelsModeLinspace": "Ravnomjerno raspoređeno (broj)",
  "forecastMaps.levelsStep": "Korak",
  "forecastMaps.levelsValues": "Vrijednosti",
  "forecastMaps.levelsValuesHint": "Odvojene zarezima, uzlazno",
  "forecastMaps.localTimeHint": "Prikazano u vašem lokalnom vremenu",
  "forecastMaps.map": "Karta",
  "forecastMaps.mapDescription": "Opis",
  "forecastMaps.mapName": "Naziv karte",
  "forecastMaps.mapNameRequired": "Unesite naziv",
  "forecastMaps.mapSettings": "Postavke karte",
  "forecastMaps.mapView": "Interaktivna karta",
  "forecastMaps.maxLayersReached": "Ova je karta dosegla maksimum od {max} slojeva.",
  "forecastMaps.maxValue": "Maksimalna vrijednost",
  "forecastMaps.memoryBudgetExceeded": "Razlučivost premašuje proračun iscrtavanja — smanjite DPI ili visinu",
  "forecastMaps.memoryBudgetUsage": "Proračun iscrtavanja: {percent}%",
  "forecastMaps.metaDescription": "Animirane prognostičke karte izrađene iz izračuna meteoroloških modela.",
  "forecastMaps.metric": "Veličina",
  "forecastMaps.metricRequired": "Odaberite veličinu",
  "forecastMaps.metricUnavailable": "Nije dostupno za ovaj model",
  "forecastMaps.minBelowMax": "Minimum mora biti manji od maksimuma",
  "forecastMaps.minMaxRequired": "Minimalna i maksimalna vrijednost obavezne su za ovu vrstu sloja",
  "forecastMaps.minValue": "Minimalna vrijednost",
  "forecastMaps.modelNoRun": "Još nema dovršenog izračuna",
  "forecastMaps.moveLayerDown": "Pomakni dolje",
  "forecastMaps.moveLayerUp": "Pomakni gore",
  "forecastMaps.myMaps": "Moje karte",
  "forecastMaps.nanClipToMin": "Ograniči na minimum",
  "forecastMaps.nanMask": "Maskiraj",
  "forecastMaps.nanPolicy": "Nedostajući podaci",
  "forecastMaps.nanSkip": "Preskoči",
  "forecastMaps.newMap": "Nova karta",
  "forecastMaps.noCompletedRun": "Ova karta još nije izrađena. Provjerite ponovno uskoro.",
  "forecastMaps.noLayers": "Još nema slojeva. Dodajte sloj za početak.",
  "forecastMaps.noMapsAvailable": "Prognostičke karte još nisu dostupne.",
  "forecastMaps.north": "Sjever",
  "forecastMaps.opacity": "Neprozirnost",
  "forecastMaps.overlayLegend": "Legenda",
  "forecastMaps.pause": "Pauza",
  "forecastMaps.play": "Reproduciraj",
  "forecastMaps.pointValueError": "Prognozu za ovu točku nije moguće učitati.",
  "forecastMaps.pointValueLoading": "Učitavanje prognoze…",
  "forecastMaps.pointValueUnavailable": "Nema podataka za ovo vrijeme.",
  "forecastMaps.presets": "Predlošci",
  "forecastMaps.preview": "Pretpregled",
  "forecastMaps.previewEmptyHint": "Postavite barem jedan valjan sloj za iscrtavanje pretpregleda.",
  "forecastMaps.previewFailed": "Pretpregled nije uspio",
  "forecastMaps.previewHour": "Sat prognoze",
  "forecastMaps.previewRendering": "Iscrtavanje pretpregleda…",
  "forecastMaps.projection": "Projekcija",
  "forecastMaps.projectionLambertConformal": "Lambertova konformna",
  "forecastMaps.projectionMercator": "Mercatorova",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Stereografska",
  "forecastMaps.regionEurope": "Europa",
  "forecastMaps.regionNorthAmerica": "Sjeverna Amerika",
  "forecastMaps.removeColor": "Ukloni boju",
  "forecastMaps.removeLayer": "Ukloni sloj",
  "forecastMaps.retry": "Pokušaj ponovno",
  "forecastMaps.run": "Izračun: {run}",
  "forecastMaps.save": "Spremi",
  "forecastMaps.selectExtentOnMap": "Odaberi područje na karti",
  "forecastMaps.south": "Jug",
  "forecastMaps.title": "Prognostičke karte",
  "forecastMaps.uMetric": "U-komponenta",
  "forecastMaps.unitConversion": "Pretvorba jedinica",
  "forecastMaps.unitNone": "Bez pretvorbe",
  "forecastMaps.unsavedChangesBody": "Imate nespremljene promjene. Izaći i odbaciti ih?",
  "forecastMaps.unsavedChangesTitle": "Nespremljene promjene",
  "forecastMaps.useCurrentView": "Koristi trenutačni prikaz",
  "forecastMaps.useModelDomain": "Isključeno: koristi se cijela domena modela",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "Veličine U i V moraju se razlikovati",
  "forecastMaps.validTime": "Vrijedi: {time}",
  "forecastMaps.valueBetween": "Mora biti između {min} i {max}",
  "forecastMaps.variable": "Varijabla",
  "forecastMaps.viewMap": "Prikaži kartu",
  "forecastMaps.vMetric": "V-komponenta",
  "forecastMaps.west": "Zapad",
  "forecastMaps.windAnimation": "Animacija vjetra",
  "intro.locationDescription": "Omogućite pristup lokaciji za točne vremenske prognoze prilagođene vašem točnom području — bez univerzalnih prognoza.",
  "intro.locationTitle": "Prognoze izrađene za vas",
  "intro.notificationDescription": "Uključite obavijesti za pravovremena upozorenja o vremenskim promjenama koje su vam važne — kiša, snijeg ili ozbiljni uvjeti, upravo kad vam trebaju.",
  "intro.notificationsTitle": "Nikada ne propustite vremenske promjene",
  "intro.readyDescription": "Uživajte u preciznim prognozama, vremenskim uvidima u stvarnom vremenu i podacima sa stanica širom svijeta — sve u jednoj moćnoj aplikaciji.",
  "intro.readyTitle": "Spremni ste!",
  "intro.welcomeDescription": "Dobijte hiperlokalne prognoze od najboljih meteoroloških agencija — plus pristup više od 40.000 meteoroloških stanica diljem svijeta za stvarne uvjete, prošle i sadašnje.",
  "intro.welcomeTitle": "Vaša vremenska prognoza, ponovno osmišljena",
  "landing.alerts": "upozorenja",
  "landing.alertsDescription": "Izradite vlastita upozorenja i primajte obavijesti čim se pokrenu.",
  "landing.featureAlertsDescription": "Postavite prilagođena upozorenja za uvjete koji vas zanimaju—temperatura, vjetar, oborine i više.",
  "landing.featureAlertsTitle": "Pametna upozorenja",
  "landing.featureAnalyticsDescription": "Uronite u svoje podatke s interaktivnim grafikonima, usporedbama jedan pored drugog i analizom trendova izvan osnovnih metrika.",
  "landing.featureAnalyticsTitle": "Moćna analitika",
  "landing.featureExportDescription": "Preuzmite svoje podatke u CSV formatu za analizu u Excelu, integraciju s drugim sustavima ili sigurnosnu kopiju.",
  "landing.featureExportTitle": "Izvoz bilo gdje",
  "landing.featureForecastDescription": "Usporedite prognoze iz više od 10 vremenskih modela uključujući GFS, ECMWF, ICON i druge da vidite koji najbolje funkcionira za vašu lokaciju.",
  "landing.featureForecastTitle": "Usporedba prognoza",
  "landing.featureHistoryDescription": "Pristup povijesnim podacima sa satnom, dnevnom i mjesečnom skalom. Izvoz u CSV za istraživanje ili osobne arhive.",
  "landing.featureHistoryTitle": "Bogata povijest",
  "landing.featureMultiBrandDescription": "Povežite postaje od Netatmo, Ecowitt, Ambient Weather, Davis, WeatherFlow i drugih—sve na jednoj nadzornoj ploči.",
  "landing.featureMultiBrandTitle": "Podrška za više marki",
  "landing.featuresSubtitle": "Dizajnirano za ljubitelje vremena koji zahtijevaju više od osnovne aplikacije vremenske postaje.",
  "landing.featuresTitle": "Sve što trebate za analizu vremena",
  "landing.finalCtaButton": "Stvorite besplatan račun",
  "landing.finalCtaSubtitle": "Pridružite se tisućama ljubitelja vremena koji vjeruju SmartMixinu za svoje vremenske podatke.",
  "landing.finalCtaTitle": "Spremni poboljšati svoje vremensko iskustvo?",
  "landing.forecastDescription": "Pristupite nekim od najboljih modela vremenske prognoze i usporedite ih kako biste dobili vlastitu predodžbu o tome kakvo će vrijeme biti.",
  "landing.forecasts": "Prognoze",
  "landing.heroCta": "Započnite besplatno",
  "landing.heroDescription": "Povežite više vremenskih postaja bilo koje marke, usporedite modele prognoze i analizirajte svoje podatke s detaljnim grafikonima i izvozom.",
  "landing.heroSecondaryCta": "Pogledajte značajke",
  "landing.heroTagline": "Za ljubitelje vremena",
  "landing.heroTitle": "Svi vremenski podaci. Jedna platforma.",
  "landing.pricingFeatureAdvancedMetrics": "Napredne metrike",
  "landing.pricingFeatureAlerts": "Prilagođena upozorenja",
  "landing.pricingFeatureExport": "Izvoz podataka (CSV)",
  "landing.pricingFeatureForecastComparison": "Usporedba prognoza",
  "landing.pricingFeatureForecasts": "Modeli prognoze",
  "landing.pricingFeatureForecastsFreeTier": "1 model",
  "landing.pricingFeatureForecastsPremiumTier": "Svi modeli (10+)",
  "landing.pricingFeatureReports": "Analize i izvještaji",
  "landing.pricingFeatureStationComparison": "Usporedba postaja",
  "landing.pricingFeatureWidgets": "Widgeti za početni zaslon",
  "landing.pricingFeatureYearOverYear": "Analiza godina za godinom",
  "landing.pricingFree": "Besplatno",
  "landing.pricingFreeCta": "Započnite",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Najpopularnije",
  "landing.pricingPremium": "Premium",
  "landing.pricingPremiumCta": "Započnite",
  "landing.pricingPremiumDescription": "Od 1,99 €/mjesec — pretplatite se na webu, App Storeu ili Google Playu",
  "landing.pricingSubtitle": "Započnite besplatno, nadogradite kada trebate više.",
  "landing.pricingTitle": "Jednostavne, transparentne cijene",
  "landing.smartMixinDescription": "SmartMixin je aplikacija koja omogućuje pristup vašoj meteorološkoj stanici i 40K+ drugim stanicama diljem svijeta. Pomaže vam vidjeti i razumjeti vremenske podatke.",
  "landing.statBrands": "Podržane marke",
  "landing.statForecasts": "Prognostički modeli",
  "landing.statStations": "Povezanih postaja",
  "landing.supportedDevices": "Podržani uređaji",
  "landing.supportedDevicesDescription": "Osim postaja Svjetske meteorološke organizacije, SmartMixin podržava sve veći broj marki meteoroloških stanica.",
  "landing.supportedDevicesNote": "Plus više od 40.000 javnih postaja Svjetske meteorološke organizacije",
  "landing.supportedDevicesSubtitle": "Povežite vremenske postaje vodećih marki i pregledajte sve podatke na jednom mjestu.",
  "landing.supportedDevicesTitle": "Radi s vašim postajama",
  "landing.thermostatDescription": "Povežite svoj Netatmo termostat za usporedbu obrazaca grijanja s vanjskim uvjetima.",
  "landing.thermostatManufacturers": "Proizvođači termostata također imaju podršku za povezivanje grijanja s vanjskim uvjetima.",
  "landing.thermostatTitle": "Integracija s pametnim domom",
  "landing.weatherAnalysis": "Analiza vremena",
  "landing.weatherAnalysisDescription": "SmartMix dolazi s puno vizualizacije podataka koja vam omogućuje analizu vremenskih podataka.",
  "landing.weatherAssistant": "Vaš vremenski asistent",
  "landing.weatherAssistantDescription": "Bilo da vas zanimaju trenutni, povijesni ili prognozirani vremenski uvjeti, SmartMixin pruža brojne uvide kad god vam zatrebaju.",
  "landing.weatherForecastModels": "Modeli vremenske prognoze",
  "landing.weatherForecastModelsDescription": "SmartMixin omogućuje pristup najpreciznijim modelima vremenske prognoze. Možete jednostavno usporediti njihove prognoze i stvoriti vlastitu ideju.",
  "landing.weatherMap": "Vremenska karta",
  "landing.weatherMapDescription": "Pregledajte kartu i vizualizirajte kakvo je vrijeme bilo gdje diljem svijeta.",
  "network.cancelError": "Zahtjev je otkazan",
  "network.connectionError": "Server je nedostupan",
  "network.networkError": "Mreža nije dostupna",
  "network.serverError": "Nešto nije u redu...",
  "network.timeoutError": "Povezivanje je isteklo",
  "network.unknownError": "Nepoznata greška",
  "providerHints.ambientWeatherApiKey": "Stvoreno u postavkama računa na ambientweather.net.",
  "providerHints.davisApiSecret": "Prikazan samo jednom prilikom stvaranja V2 API ključa — čuvajte ga sigurno.",
  "providerHints.davisV2ApiKey": "Sa stranice V2 API ključeva na weatherlink.com.",
  "providerHints.ecowittApi": "Sa stranice API vašeg Ecowitt računa.",
  "providerHints.ecowittApp": "Ključ aplikacije, također iz vašeg Ecowitt računa.",
  "providerHints.myAcuriteCredentialsBanner": "Koristite e-poštu i lozinku vašeg My AcuRite računa — ne SmartMixin prijavu.",
  "providerHints.myAcuriteEmail": "E-pošta vašeg My AcuRite računa — ne vaša SmartMixin prijava.",
  "providerHints.myAcuritePassword": "Lozinka vašeg My AcuRite računa.",
  "providerHints.weatherflowToken": "Token za osobnu uporabu s tempestwx.com → postavke → autorizacije podataka.",
  "providerHints.wundergroundEditKey": "Koristi drugi ključ",
  "providerHints.wundergroundKey": "Dugi niz znakova sa stranice API ključeva vašeg Weather Underground računa — ne vaša lozinka za wunderground.com.",
  "providerHints.wundergroundKeyExample": "npr. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API ključ provjeren",
  "providerHints.wundergroundKeyVerifying": "Provjera ključa…",
  "providerHints.wundergroundNoStationsNearby": "Nije pronađena nijedna stanica u blizini. Pokušajte unijeti ID stanice izravno.",
  "providerHints.wundergroundStationId": "Bilo koja oznaka stanice Weather Underground — vaša ili javna stanica u blizini.",
  "providerHints.wundergroundStationIdExample": "npr. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Nabavite svoj Ambient Weather API ključ.",
  "providerIntro.davisStep2": "Nabavite svoj Davis V2 API ključ i API tajnu.",
  "providerIntro.ecowittStep2": "Nabavite svoj Ecowitt API ključ i ključ aplikacije.",
  "providerIntro.getStarted": "Započni",
  "providerIntro.myAcuriteStep2": "Koristite e-poštu i lozinku svog postojećeg My AcuRite računa.",
  "providerIntro.netatmoEnergyStep2": "Prijavite se u Netatmo kada budete upitani — API ključ nije potreban.",
  "providerIntro.netatmoWeatherStep2": "Prijavite se u Netatmo kada budete upitani — API ključ nije potreban.",
  "providerIntro.signupBanner": "Skoro gotovo — stvorite svoj besplatni SmartMixin račun za povezivanje {provider}.",
  "providerIntro.step1": "Prijavite se u svoj SmartMixin račun (NE u {provider}).",
  "providerIntro.step3EmailPassword": "Unesite ih ovdje.",
  "providerIntro.step3KeyOrToken": "Zalijepite ovdje.",
  "providerIntro.step3OAuth": "Autorizirajte SmartMixin u skočnom prozoru.",
  "providerIntro.step3Wunderground": "Zalijepite svoj API ključ, a zatim odaberite obližnju stanicu ili unesite bilo koji ID stanice.",
  "providerIntro.title": "Poveži {provider}",
  "providerIntro.weatherflowStep2": "Nabavite svoj osobni Tempest token.",
  "providerIntro.wundergroundBrowsePublic": "Nemate stanicu? Pregledajte javne",
  "providerIntro.wundergroundFindNearby": "Pronađi stanice u blizini",
  "providerIntro.wundergroundOrEnterId": "Ili unesite ID stanice",
  "providerIntro.wundergroundStep2": "Nabavite svoj Weather Underground API ključ. Zatim možete povezati bilo koju stanicu — svoju ili javnu.",
  "reports.agroMeteorology": "Agrometeorologija",
  "reports.analysis": "Analiza",
  "reports.annualCumulativeRainfallComparison": "Usporedba ukupnih godišnjih oborina",
  "reports.annualHeatingDurationComparison": "Godišnja usporedba vremena grijanja",
  "reports.annualHeatingEfficiency": "Godišnja učinkovitost grijanja",
  "reports.annualIndoorComparison": "Godišnje usporedbe unutrašnjeg modula",
  "reports.annualIndoorReport": "Godišnji izvještaj o unutrašnjem modulu",
  "reports.annualOutdoorComparison": "Godišnja usporedba vanjskog modula",
  "reports.annualOutdoorReport": "Godišnji izvještaj o vanjskom modulu",
  "reports.annualReport": "Godišnji izvještaj",
  "reports.annualSolarReport": "Godišnje solarno izvješće",
  "reports.annualWaterBalance": "Godišnja vodna bilanca",
  "reports.annualWaterBalanceCarryOver": "Prenesi iz prethodne godine",
  "reports.annualWaterBalanceDescription": "Vodna bilanca (pojednostavljena verzija, koriste se samo kiša i evapotranspiracija) omogućuje upravljanje vodnim resursima",
  "reports.avgHumidity": "Prosječna vlažnost zraka",
  "reports.avgMaxTemperature": "Prosječna T°max",
  "reports.avgMetric": "Prosjek – {metric}",
  "reports.avgMinTemperature": "Prosječna T°min",
  "reports.avgPressure": "Prosječna vrijednost tlaka zraka",
  "reports.avgTemperature": "Prosječna temperatura",
  "reports.climateNormalPeriodOfRecord": "Razdoblje mjerenja ({years, plural, one {# godina} few {# godine} other {# godina}})",
  "reports.climateNormals": "Klimatske normale",
  "reports.climateNormalStandardLabel": "Standardna normala ({period})",
  "reports.climateTrendPerDecade": "Trend temperature: {value} po desetljeću tijekom {years, plural, one {# godine} few {# godine} other {# godina}}",
  "reports.coldestMonthRanking": "{month} – rekord hladnoće",
  "reports.comfortable": "Ugodna (45% {lessThan} vlažnost zraka ≤ 60%)",
  "reports.cumulativeRainfall": "Kumulativne oborine",
  "reports.cumulativeRainfallDescription": "Pratite ukupne oborine koje se akumuliraju tijekom odabranog razdoblja.",
  "reports.dailyMaxRainfall": "Maksimalne dnevne oborine",
  "reports.dataExport": "Izvezi podatke",
  "reports.dataExportXlsxFormatDescription": "Izvezite sve vaše podatke u excel datoteku (*.xlsx). Nakon što kliknete na gumb, nakon par minuta će vam stići email sa obrađenim podacima.",
  "reports.daysOfData": "{days, plural, one {# dan} few {# dana} other {# dana}} podataka",
  "reports.daysWithFrost": "Dani sa mrazom",
  "reports.daysWithHeavyRain": "Dani s jakom kišom (≥ {threshold})",
  "reports.daysWithoutThaw": "Ledeni dani (T°max < 0°C)",
  "reports.daysWithStrongFrost": "Dani sa jakim mrazom",
  "reports.emailSent": "Email je poslat na vašu adresu",
  "reports.frostDays": "Mrazni dani",
  "reports.grasslandTemperatureSum": "Zbroj temperatura travnjaka",
  "reports.grasslandTemperatureSumDescription": "Održivi oporavak vegetacije kada zbroj dosegne {threshold}",
  "reports.growingDegreeDays": "Rastući stupanj-dani",
  "reports.highPressure": "Anticiklona (Prosječna vrijednost tlaka zraka ≥ 1013mbar)",
  "reports.iceDays": "Ledeni dani",
  "reports.indoorReport": "Izvještaj unutrašnjeg modula",
  "reports.keyFacts": "Važne činjenice",
  "reports.longestDrySpell": "Najdulje sušno razdoblje",
  "reports.longestRunOfRainyDays": "Broj uzastopnih kišnih dana",
  "reports.longestRunWithoutRun": "Broj uzastopnih dana bez kiše",
  "reports.longestWetSpell": "Najdulje kišno razdoblje",
  "reports.lowPressure": "Nizak tlak (prosječna vrijednost tlaka zraka {lessThan} 1013 mbar)",
  "reports.maxHumidity": "Maksimalna vlažnost",
  "reports.maxMetric": "Maksimum – {metric}",
  "reports.maxPressure": "Najviši tlak",
  "reports.maxPressureMagnitude24h": "Maksimalna promjena (/24H)",
  "reports.maxTemperature": "Najviša temperatura",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Maksimalna promjena (/24H)",
  "reports.minHumidity": "Minimalna vlažnost",
  "reports.minMetric": "Minimum – {metric}",
  "reports.minPressure": "Najniži tlak",
  "reports.minPressureMagnitude24h": "Minimalna promjena (/24H)",
  "reports.minTemperature": "Najniža temperatura",
  "reports.minTempMagnitude24h": "Minimalna promjena (/24H)",
  "reports.monthlyAverageCountdown": "{days, plural, one {Još # dan} few {Još # dana} other {Još # dana}} ovaj mjesec",
  "reports.monthlyAverageCountdownDetail": "Tada se pojavljuju prosjek ovog mjeseca i njegov poredak.",
  "reports.monthlyAverageRule": "Mjesečni prosjeci i poreci pojavljuju se kada kalendarski mjesec ima zabilježeno {days, plural, one {# dan} few {# dana} other {# dana}}.",
  "reports.monthlyHeatingEfficiency": "Mjesečna učinkovitost grijanja",
  "reports.monthlyIndoorReport": "Mjesečni izvještaj unutrašnjeg modula",
  "reports.monthlyOutdoorReport": "Mjesečni izvještaj vanjskog modula",
  "reports.monthlyReport": "Mjesečni izvještaj",
  "reports.monthlySolarReport": "Mjesečni solarni izvještaj",
  "reports.monthlyWindReport": "Mjesečni izvještaj o vjetru",
  "reports.monthsOfData": "{months, plural, one {# mjesec} few {# mjeseca} other {# mjeseci}} podataka",
  "reports.numberOfDays": "Broj dana",
  "reports.onThisDayInHistory": "Na današnji dan u povijesti",
  "reports.outdoorReport": "Izvještaj vanjskog modula",
  "reports.overviewSection": "Pregled",
  "reports.rainfall": "Oborine",
  "reports.rainyDays": "Dani sa oborinama",
  "reports.recordDailyRain": "Najkišovitiji dan",
  "reports.recordHigh": "Rekordna vrućina",
  "reports.recordLow": "Rekordna hladnoća",
  "reports.recordsAndClimatology": "Rekordi i klima",
  "reports.recordsSince": "Rekordi od {date}",
  "reports.recordWindGust": "Najjači udar vjetra",
  "reports.relativelyWet": "Relativno vlažno (60% {lessThan} Vlažnost ≤ 80%)",
  "reports.sectionReportCount": "{count, plural, one {# izvješće} few {# izvješća} other {# izvješća}}",
  "reports.sendEmail": "Pošalji email",
  "reports.summerDays": "Ljetni dani",
  "reports.tooDry": "Presuho (Vlažnost ≤ 45%)",
  "reports.tooWet": "Sparno (Vlažnost {greaterThan} 80%)",
  "reports.tropicalNights": "Tropske noći",
  "reports.unlockPremiumSubtitle": "Uključeno u SmartMixin Premium",
  "reports.unlockPremiumTitle": "Otključajte {count, plural, one {# premium značajku} few {# premium značajke} other {# premium značajki}}",
  "reports.warmestMonthRanking": "{month} – rekord vrućine",
  "reports.waterBalance": "Ravnoteža vode",
  "reports.yearsOfData": "{years, plural, one {# godina} few {# godine} other {# godina}} podataka",
  "reports.yearToDateTemperatureComparison": "Usporedba temperature od početka godine",
  "sensors.aqiByChannel": "AQI po kanalu",
  "sensors.bgtSensors": "Crni globus & WBGT",
  "sensors.cameraFeed": "Kamera",
  "sensors.compareAqi": "Usporedi AQI",
  "sensors.compareHumidity": "Usporedi vlažnost",
  "sensors.compareMoisture": "Usporedi vlagu tla",
  "sensors.comparePm25": "Usporedi PM2.5",
  "sensors.compareTemperatures": "Usporedi temperature",
  "sensors.depthByChannel": "Dubina po kanalu",
  "sensors.heatStressExtreme": "Ekstreman toplinski stres",
  "sensors.heatStressModerate": "Umjeren toplinski stres",
  "sensors.heatStressNone": "Nema toplinskog stresa",
  "sensors.heatStressStrong": "Jak toplinski stres",
  "sensors.heatStressVeryStrong": "Vrlo jak toplinski stres",
  "sensors.humidityByChannel": "Vlažnost po kanalu",
  "sensors.indoorAirQualityPm": "PM2.5 i PM10 AQI",
  "sensors.indoorClimate": "Unutarnja klima",
  "sensors.indoorCo2Levels": "Razine CO2",
  "sensors.indoorTemperatureAndHumidity": "Temperatura i vlažnost",
  "sensors.last24Hours": "24 sata",
  "sensors.last30Days": "30 dana",
  "sensors.last7Days": "7 dana",
  "sensors.leafTemperatureByChannel": "Temperatura listova po kanalu",
  "sensors.leafWetnessByChannel": "Vlažnost listova po kanalu",
  "sensors.lightningSensor": "Munja",
  "sensors.moistureByChannel": "Vlaga tla po kanalu",
  "sensors.noDataAvailable": "Nema dostupnih podataka",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 po kanalu",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Odaberite kanal",
  "sensors.sensorDetailDescription": "Pregledajte povijesne podatke i trendove za kanale senzora.",
  "sensors.sensorHistory": "Povijest senzora",
  "sensors.soilConductivityByChannel": "Vodljivost po kanalu",
  "sensors.soilTemperatureByChannel": "Temperatura tla po kanalu",
  "sensors.strikesToday": "Udari danas",
  "sensors.temperatureByChannel": "Temperatura po kanalu",
  "sensors.viewChart": "Prikaži grafikon",
  "settings.about": "O programu",
  "settings.aboutDescription": "Sporazum o licenci, politika privatnosti",
  "settings.account": "Račun",
  "settings.accountDescription": "Profil, promjena lozinke",
  "settings.accountIntro": "Podaci koji se tiču računa:",
  "settings.accountOnHoldTitle": "Račun pauziran",
  "settings.accountSection": "Račun",
  "settings.addForecastModel": "Dodaj model",
  "settings.appearance": "Izgled",
  "settings.appearanceDescription": "Tema i opcije prikaza",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "arapski",
  "settings.atYourStations": "Dostupni na vašim postajama",
  "settings.availableServices": "Dostupno",
  "settings.bulgarian": "bugarski",
  "settings.cannotDisconnectLastAccount": "Nije moguće odspojiti jedinu metodu prijave. Prvo dodajte drugu metodu prijave.",
  "settings.catalan": "katalonski",
  "settings.changeEmail": "Promijeni e-mail",
  "settings.changePassword": "Promijeni lozinku",
  "settings.chartGestures": "Geste na dijagramu",
  "settings.chartGesturesDescription": "Prelaskom preko dijagrama mijenjate period, skupljanjem prstima mijenjate vremensku skalu",
  "settings.choiceCount": "{count, plural, one {Dostupno: #} few {Dostupno: #} other {Dostupno: #}}",
  "settings.connect": "Poveži",
  "settings.connected": "Povezano",
  "settings.connectedAccounts": "Povezani računi",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "Povezano",
  "settings.connectedSince": "Povezano od {date}",
  "settings.connectionSection": "Veza",
  "settings.connectionSuccess": "{provider} račun uspješno povezan",
  "settings.contactUs": "Kontaktirajte nas",
  "settings.contactUsDescription": "Zatražite pomoć ili pošaljite povratnu informaciju",
  "settings.coverageLoading": "Utvrđujemo koje vaše postaje pokriva svaki model…",
  "settings.croatian": "hrvatski",
  "settings.currentPassword": "Trenutna lozinka",
  "settings.czech": "češki",
  "settings.dailyDetailByPeriods": "Dnevni detalji po razdobljima",
  "settings.dailyDetailByPeriodsDescription": "Grupiraj 24 sata u noć, jutro, poslijepodne i večer — ista podjela koju koristi dnevni sažetak.",
  "settings.dangerZone": "Rizična zona",
  "settings.danish": "danski",
  "settings.dark": "Tamna tema",
  "settings.dataDisplay": "Prikaz podataka",
  "settings.dateAndTime": "Datum i sat",
  "settings.disconnect": "Odspoji",
  "settings.disconnectConfirmation": "Jeste li sigurni da želite odspojiti {provider} račun?",
  "settings.disconnectionSuccess": "{provider} račun uspješno odspojen",
  "settings.disconnectProviderDescription": "Zaustavlja sinkronizaciju. Vaša povijest se čuva.",
  "settings.donateButton": "Donirajte",
  "settings.donateDescription": "SmartMixin razvija mali tim. Ako vam je koristan, možete podržati njegov razvoj jednokratnom donacijom u bilo kojem iznosu. To je dar — ne mijenja vaš plan niti otključava ikakve značajke.",
  "settings.donateSuccessBody": "Vaša donacija pomaže da SmartMixin nastavi raditi i da se poboljšava. Iskreno to cijenimo.",
  "settings.donateSuccessTitle": "Hvala vam na podršci!",
  "settings.donateTitle": "Podržite SmartMixin",
  "settings.dragToReorder": "Povucite za promjenu redoslijeda",
  "settings.dutch": "nizozemski",
  "settings.emailChange": "Promijeni e-mail adresu",
  "settings.emailChangeConfirmation": "Potvrda promjene e-maila",
  "settings.emailChangeFailure": "Poveznica za promjenu e-maila je nevažeća ili je istekla.",
  "settings.emailChangeSuccess": "Vaš e-mail je uspješno promijenjen u {newEmail}.",
  "settings.emailChangeVerificationSent": "Verifikacijski e-mail je poslan na vašu novu e-mail adresu. Provjerite svoju pristiglu poštu i kliknite na poveznicu za potvrdu promjene.",
  "settings.english": "engleski",
  "settings.everywhereElse": "Svugdje drugdje",
  "settings.everywhereElseFoot": "Koristi se na svakoj postaji do koje vaši preferirani modeli ne dosežu.",
  "settings.everywhereElsePick": "Odaberite jedan",
  "settings.fallbackBlend": "SmartMixin mješavina",
  "settings.fallbackBlendSub": "Kombinira više modela, svaki ondje gdje je najjači.",
  "settings.fallbackEcmwf": "ECMWF",
  "settings.fallbackEcmwfSub": "ECMWF HRES svugdje gdje doseže.",
  "settings.fallbackGfs": "GFS",
  "settings.fallbackGfsSub": "NOAA-in globalni model. Ono što danas koristi svaki račun.",
  "settings.fallbackResolution": "Najviša razlučivost",
  "settings.fallbackResolutionSub": "Najfinija mreža dostupna na svakoj postaji.",
  "settings.forecastModels": "Modeli prognoze",
  "settings.freeBannerBody": "Besplatni računi svugdje dobivaju GFS — preferirani modeli i „svugdje drugdje” počinju raditi čim se pretplatite.",
  "settings.freeBannerTitle": "Postavke vrijede uz Premium",
  "settings.french": "francuski",
  "settings.german": "njemački",
  "settings.gestures": "Geste",
  "settings.greek": "grčki",
  "settings.helpCenter": "Centar za pomoć",
  "settings.helpCenterDescription": "Često postavljana pitanja i vodiči",
  "settings.hungarian": "mađarski",
  "settings.integrationsSection": "Integracije",
  "settings.italian": "italijanski",
  "settings.japanese": "japanski",
  "settings.korean": "korejski",
  "settings.language": "Jezik",
  "settings.languageDescription": "Jezik po izboru",
  "settings.light": "Svijetla tema",
  "settings.measurementUnits": "Mjerne jedinice",
  "settings.newEmailAddress": "Nova e-mail adresa",
  "settings.newPassword": "Nova zaporka",
  "settings.newPasswordAgain": "Ponovite novu zaporku",
  "settings.norwegian": "norveški",
  "settings.notConnected": "Nije povezano",
  "settings.notificationsSection": "Obavijesti",
  "settings.oldPassword": "Stara zaporka",
  "settings.ongoingNotificationEnabled": "Omogući trajnu obavijest",
  "settings.ongoingNotificationMetrics": "Prikazane metrike",
  "settings.ongoingNotificationPermissionRequired": "Potrebna je dozvola za obavijesti",
  "settings.ongoingNotificationPreviewHint": "Pregled — uključite widget da bi se prikazao",
  "settings.ongoingNotificationStation": "Meteorološka postaja",
  "settings.ongoingNotificationStatusBar": "Statusna traka",
  "settings.passwordChange": "Promjena zaporke",
  "settings.passwordChangeDescription": "Održite svoj račun sigurnim",
  "settings.pickerShowAll": "Prikaži cijeli katalog",
  "settings.pickerUnreachable": "{count, plural, one {# dodatni model ne doseže} few {# dodatna modela ne dosežu} other {# dodatnih modela ne doseže}} nijednu vašu postaju",
  "settings.pinInUse": "U upotrebi",
  "settings.pinShadowed": "Nikad se ne koristi — model iznad pokriva sve vaše postaje",
  "settings.pinSlots": "{used} od {max} · dodirnite za odabir",
  "settings.pinSlotsFull": "Svih {max} mjesta je zauzeto. Uklonite jedno da dodate drugo.",
  "settings.pinsUncoveredCount": "{used} od vaših {count, plural, one {# postaje} few {# postaje} other {# postaja}}: nijedan preferirani model ne doseže do njih — odlučuje „svugdje drugdje”.",
  "settings.pinsUncoveredNamed": "{stations}: nijedan preferirani model ne doseže do {count, plural, one {nje} other {njih}} — odlučuje „svugdje drugdje”.",
  "settings.pinUnreachable": "Nikad se ne koristi — ne doseže nijednu vašu postaju",
  "settings.pinUsedAt": "Koristi se na {stations}",
  "settings.pinUsedAtAll": "{count, plural, one {Koristi se na vašoj postaji} few {Koristi se na svih # postaja} other {Koristi se na svih # postaja}}",
  "settings.pinUsedAtSome": "Koristi se na {used} od {count, plural, one {# postaje} few {# postaje} other {# postaja}}",
  "settings.polish": "poljski",
  "settings.portuguese": "portugalski",
  "settings.preferencesSection": "Postavke",
  "settings.preferredModels": "Preferirani modeli",
  "settings.preferredModelsAll": "Jedan popis, sve postaje",
  "settings.preferredModelsOne": "Jedan popis, vrijedi svugdje",
  "settings.premium": "Premium",
  "settings.premiumActive": "Aktivno",
  "settings.premiumAnnualThenPrice": "Zatim 9,99 €/godišnje",
  "settings.premiumAnnualTrialInfo": "Započnite s besplatnim probnim razdobljem od {days} dana",
  "settings.premiumCurrentPlan": "Trenutni plan",
  "settings.premiumDescription": "Otključaj pogodnosti premium računa",
  "settings.premiumDownloadApp": "Preuzmite aplikaciju za pretplatu:",
  "settings.premiumExpiresOn": "Obnavlja se {date}",
  "settings.premiumFreePlan": "Besplatno",
  "settings.premiumInactive": "Bez pretplate",
  "settings.premiumManageWebSubscription": "Upravljajte pretplatom, ažurirajte način plaćanja ili otkažite.",
  "settings.premiumPremiumPlan": "Premium",
  "settings.premiumSubscribeAnnual": "Godišnje — 9,99 €/godina",
  "settings.premiumSubscribedOn": "Pretplaćeno putem {platform}",
  "settings.premiumSubscribeMonthly": "Mjesečno — 1,99 €/mjesec",
  "settings.premiumSubscribeOnWeb": "Pretplatite se sada kako biste otključali sve premium značajke.",
  "settings.premiumSubscriptionSuccess": "Vaša pretplata je aktivirana! Uživajte u svim premium značajkama.",
  "settings.premiumSubscriptionSuccessTitle": "Dobrodošli u Premium!",
  "settings.premiumWebappNotice": "Pretplate se mogu kupiti samo putem mobilne aplikacije SmartMixin za iOS ili Android.",
  "settings.privacyPolicy": "Politika privatnosti",
  "settings.profile": "Profil",
  "settings.removePreferredModel": "Ukloni {model} iz preferiranih modela",
  "settings.resetForecastPreference": "Vrati zadano",
  "settings.resetForecastPreferenceHint": "Briše vaše preferirane modele i vraća zadanu postavku SmartMixina.",
  "settings.russian": "ruski",
  "settings.seePremium": "Pogledaj Premium",
  "settings.serbian": "srpski",
  "settings.servedNowMany": "Upravo sada: GFS {count, plural, one {na vašoj postaji} few {na svih # postaja} other {na svih # postaja}}.",
  "settings.servedNowNone": "Upravo sada: GFS svugdje.",
  "settings.settings": "Podešavanja",
  "settings.signedInAs": "Prijavljeni kao",
  "settings.slovak": "slovački",
  "settings.smallDecimals": "Male decimale",
  "settings.smallDecimalsDescription": "Prikaži decimalne znamenke u manjoj veličini",
  "settings.socialConnectionsIntro": "Povežite svoje društvene račune za brzu prijavu. Možete povezivati ili odspajati račune u bilo kojem trenutku.",
  "settings.spanish": "španjolski",
  "settings.statusBarWidget": "Widget statusne trake",
  "settings.statusBarWidgetDescription": "Uvijek vidljivi vremenski podaci",
  "settings.subscriptionSection": "Pretplata",
  "settings.supportSection": "Podrška",
  "settings.swedish": "švedski",
  "settings.systemTheme": "Sistemska tema",
  "settings.termsOfService": "Uvjeti korištenja",
  "settings.turkish": "turski",
  "settings.ukrainian": "ukrajinski",
  "settings.units": "Jedinice",
  "settings.unitsDescription": "Mjerne jedinice unutar aplikacije",
  "settings.update": "Ažuriraj",
  "settings.updateYourProfile": "Ažurirajte vaš profil",
  "settings.updateYourProfileDescription": "Ime i postavke prikaza",
  "settings.weatherServices": "Meteorološke usluge",
  "settings.weatherServicesConnected": "{count, plural, =0 {Nema povezanih usluga} one {# povezana usluga} few {# povezane usluge} other {# povezanih usluga}}",
  "settings.weatherServicesDescription": "Povežite Netatmo, Davis, Weatherflow i ostalo",
  "settings.windDirectionConvention": "Strelica smjera vjetra",
  "settings.windDirectionConventionDescription": "Odaberite prikaz strelica smjera vjetra",
  "settings.windDirectionMeteorological": "Smjer podrijetla",
  "settings.windDirectionMeteorologicalDescription": "Strelica pokazuje odakle vjetar puše (meteorološka konvencija)",
  "settings.windDirectionOceanographic": "Smjer strujanja",
  "settings.windDirectionOceanographicDescription": "Strelica pokazuje kuda vjetar puše (oceanografska konvencija)",
  "units.absolutePressure": "Apsolutni tlak",
  "units.airDensity": "Gustoća zraka",
  "units.airGap": "Zračni razmak",
  "units.apparentTemperature": "Prividna temperatura",
  "units.AQI": "AQI",
  "units.AQI_24H": "24h AQI",
  "units.avg": "Prosjek",
  "units.avg_wind": "Prosječan vjetar",
  "units.beaufort": "Beaufort",
  "units.blackGlobeTemperature": "Temp. crnog globusa",
  "units.boilerOn": "Bojler UKLJUČEN",
  "units.co2": "CO2",
  "units.conductivity": "Vodljivost",
  "units.coolingDegreeDays": "Dani hlađenja",
  "units.dailyHeatingDuration": "Dnevno trajanje grijanja",
  "units.dailyPrecipitation": "Dnevne oborine",
  "units.dailyRain": "Dnevna kiša",
  "units.degreeDay": "Dnevni stupnjevi",
  "units.degreeDayShort": "DS",
  "units.depth": "Dubina",
  "units.depthSensors": "Senzori dubine",
  "units.dewPoint": "Točka rošenja",
  "units.distance": "Udaljenost",
  "units.downTrend": "Silazni trend",
  "units.E": "I",
  "units.E_long": "Istočno",
  "units.ENE": "ISI",
  "units.ENE_long": "istok-sjeveroistok",
  "units.ESE": "IJI",
  "units.ESE_long": "istok-jugoistok",
  "units.ET": "Evapotranspiracija",
  "units.ETshort": "I",
  "units.feelLike": "Subjektivni osjećaj",
  "units.feelsLike": "Subjektivni osjećaj",
  "units.footMile": "noga, milja",
  "units.frostPoint": "točka smrzavanja",
  "units.gust": "Udar vjetra",
  "units.heatIndex": "Indeks toplote",
  "units.heatingDegreeDays": "Dnevni stupnjevi grijanja",
  "units.heatingPower": "Snaga grijanja",
  "units.humidex": "Humidex",
  "units.humidity": "Vlažnost",
  "units.inch": "Inchi",
  "units.inchOfMercury": "Inchi živinog stupa",
  "units.kilometerPerHour": "Kilometri na sat",
  "units.knot": "Čvorovi",
  "units.last12Hours": "Posljednjih 12 sati",
  "units.last24Hours": "Posljednja 24 sata",
  "units.last3Hours": "Posljednja 3 sata",
  "units.last6Hours": "Posljednjih 6 sati",
  "units.lastHour": "Poslijednji sat",
  "units.lastLightningImpact": "Posljednji udar groma",
  "units.lastMeasure": "Poslijednje mjerenje",
  "units.leafSensors": "Senzori vlage",
  "units.leafWetness": "Vlažnost lišća",
  "units.lightningDistance": "Udaljenost",
  "units.lightningStrikeCount": "Broj udara munje",
  "units.lightningStrikeDistance": "Udaljenost udara groma",
  "units.max": "Max.",
  "units.max_gust": "Maks. udar vjetra",
  "units.max_wind": "Maks. vjetar",
  "units.meterKilometer": "metar, kilometar",
  "units.meterPerSecond": "Metri u sekundi",
  "units.milePerHour": "Milje na sat",
  "units.millibar": "Milibari",
  "units.millimeter": "Milimetri",
  "units.millimeterOfMercury": "Milimetri živinog stupa",
  "units.min": "Min.",
  "units.N": "S",
  "units.N_long": "sjeverno",
  "units.NE": "SI",
  "units.NE_long": "sjeveroistočno",
  "units.NNE": "SSI",
  "units.NNE_long": "sjever-sjeveroistok",
  "units.NNW": "SSZ",
  "units.NNW_long": "sjever-sjeverozapad",
  "units.noise": "Buka",
  "units.normalizedHeatingCoefficient": "Normalizirani kvocijent zagrijavanja",
  "units.NW": "SZ",
  "units.NW_long": "sjeverozapad",
  "units.O3": "Ozon",
  "units.PM_1": "PM 1",
  "units.PM_10": "PM 10",
  "units.PM_2P5": "PM 2.5",
  "units.precipitation": "Oborine",
  "units.pressure": "Tlak",
  "units.rain": "Kiša",
  "units.rainRate": "Intenzitet kiše",
  "units.referenceTemperature": "Referentna temperatura",
  "units.relativePressure": "Relativni tlak",
  "units.S": "J",
  "units.S_long": "jug",
  "units.SE": "JI",
  "units.SE_long": "Jugoistok",
  "units.setPoint": "Početna točka",
  "units.snow": "Snijeg",
  "units.snowfall": "Snježne oborine",
  "units.soilMoisture": "Vlažnost tla",
  "units.soilSensors": "Podni senzori",
  "units.solarEnergy": "Solarna energija",
  "units.solarRadiation": "Solarno zračenje",
  "units.speed": "Brzina",
  "units.SSE": "JJI",
  "units.SSE_long": "jug-jugoistok",
  "units.SSW": "JJZ",
  "units.SSW_long": "jug-jugozapad",
  "units.stableTrend": "Stabilan trend",
  "units.sum": "Suma",
  "units.SW": "JZ",
  "units.SW_long": "Jugozapad",
  "units.temperature": "Temperatura",
  "units.temperatureAndHumiditySensors": "Senzori temperature/vlage",
  "units.temperatureSensors": "Senzori temperature/vlage",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "Danas",
  "units.upTrend": "Uzlazni trend",
  "units.uv": "UV",
  "units.visibility": "Vidljivost",
  "units.W": "Z",
  "units.W_long": "Zapad",
  "units.wetBulbGlobeTemperature": "Temp. vlažnog globusa",
  "units.wetBulbTemperature": "Temp. mokri termometar",
  "units.wind": "Vjetar",
  "units.windChill": "Hlađenje vjetra",
  "units.windDirection": "Smjer vjetra",
  "units.windRun": "tijek vjetra",
  "units.windRunDescription": "Putovanje vjetrom je ukupna udaljenost koju prijeđe vjetar u određenom vremenskom razdoblju",
  "units.WNW": "ZSZ",
  "units.WNW_long": "zapad-sjeverozapad",
  "units.WSW": "ZJZ",
  "units.WSW_long": "zapad-jugozapad"
}
